export default {
  today: "Today",
  common: {
    confirm: "Confirm",
    back: "Back",
    plus: "PLUS",
    pro: "PRO",
  },
  notFound: {
    title: "Oh no! Error 404",
    text: "Oops! This page seems to have taken a detour. Let us help you find your way back to your goal.",
    button: "Back to Home",
  },
  dateRangePicker: {
    title: "Select period",
    startLabel: "From",
    endLabel: "To",
  },
  expiresIn: {
    day: "1 day",
    days: "{{days}} days",
    month: "1 month",
    months: "{{months}} months",
  },
  bankImportStatus: {
    importedData: "Imported bank data",
    updatedData: "Updated bank data",
    successImport: "Bank data successfully imported",
    successUpdate: "Bank data successfully updated",
    errorImport: "Bank data import failed",
    errorUpdate: "Bank data update failed",
  },
  dropdownWithSections: {
    noOptions: "No options available",
    noMatches: "No matches found",
    loading: "Loading...",
  },
  form: {
    successMessage: "Your data has been saved successfully",
    errors: {
      pdfImport:
        "Unfortunately, we could not read one or more of your PDF files, please try again",
      pdfImportFileLength:
        "You have selected more than 10 files. A maximum of 10 files can be processed. Additional files will not be accepted",
      required: " This field is required.",
      wrongEmailFormat: "Invalid email format.",
      emailsNotMatched: "Emails should match.",
      passwordMinLength: "Password should be at least 8 characters long.",
      passwordsNotMatched: "Passwords should match.",
      wrongDateFormat: " Invalid date format.",
      wrongIbanFormat:
        "IBAN is invalid. Please check this and enter a valid IBAN.",
      wrongPhoneFormat:
        "Invalid phone format. Please only use digits and the + symbol.",
      min: "This Field must be at least {{min}} characters long.",
      emailAlreadyExists: "This email address is already registered.",
      somethingWentWrong: "Something went wrong. Please try again.",
      noData: "No data available",
    },
  },
  domains: {
    dividends: {
      dividendsTable: {
        noDividends: "No dividends",
      },
    },
    accountPreviewCard: {
      updateRecommended: "Update recommended",
    },
    cashback: {
      download: {
        customerFirstName: "First name",
        customerLastName: "Last name",
        bank: "Bank",
        depotId: "Depot identifier",
        securityIsin: "ISIN",
        securityName: "Fund name",
        date: "Date",
        netCommission: "Commission",
        valuationBase: "Valuation",
        commissionType: "Commission type",
      },
      dashboard: {
        details: {
          title: "Commission-item",
          commission: "Commission for",
          evaluation: "Valuation",
        },
        summary: {
          accountingFrom: "Invoice date: ",
          download: "Download",
          notBilledYet: "Not billed yet",
          afterBilling: "After Billing",
          trailerCommission: "One-time commission",
          commissionRetention: "Commission retention",
          yourCashback: "Your Cashback",
          incomplete: "Incomplete",
          lastBills: "Last invoices",
          goToBilling: "Go to invoices",
          period: "Period",
          taxHelper: "Tax Helper",
        },
        tabs: {
          overview: "Overview",
          invoices: "Invoices",
          contacts: "Contact & Payment",
        },
        title: "My Cashback",
        breadcrumbs: {
          home: "Home",
          cashback: "Cashback",
        },
        titleAction: "New cashback subscription",
        openBookings: "My cashback subscriptions",
        showAll: "Show all",
        info: {
          title: "Invite friends and benefit twice!",
          text: "Get a <blueText>{{amount}} € cashback bonus<blueText> now for every referred friend.\nYour friend will also receive a <blueText>{{amount}} € bonus.<blueText>",
          recommend: "Recommend Rentablo",
          notNow: "Not now",
        },
        cashbackBonusBanner: {
          amountText: "{{amount}} bonus available",
          inactiveText: "• Activation after booking is complete",
        },
        footer:
          "* Your cashback-bonus will lower our fee and thus increase your cashback payout.",
        item: {
          depositNumber: "Depot Identifier",
          edit: "Edit",
          abort: "Cancel",
          pdf: "PDF",
          deleteSuccess: "The cashback subscription was successfully deleted",
        },
        status: {
          incomplete: "Please complete your subscription",
          in_progress: "Please submit documents",
          internal_processing: "Documents received",
          processing_at_bank: "Documents forwarded to your bank",
          processing_at_bank_reduced: "Opening process forwarded to bank",
          processed: "Active",
          contract_terminated: "Terminated",
          cancelled: "Cancelled",
        },
        taxHelper: {
          title: "Tax Helper",
          back: "back",
          categories: {
            EQUITY_FUND: "Equity Fund, Equity Portion > 51%",
            BALANCED_FUND: "Mixed Fund, Equity Portion > 25%",
            GERMAN_REAL_ESTATE_FUND: "Real Estate, Germany > 51%",
            FOREIGN_REAL_ESTATE_FUND: "Real estate, abroad > 51%",
            OTHERS: "Other (no exemption)",
          },
          summary: {
            period: "Period",
            taxableAmount: "Tax-relevant amount",
            export: "Export",
            exportData: "Data export",
          },
          banner: {
            title: "Exclusion of tax advice",
            text: "The information presented here does not constitute tax advice. The values and software tools provided are only intended as a guide. In particular, Rentablo does not guarantee the information displayed Values and also assumes no liability. This cannot replace individual advice from experts.",
          },
          info: {
            title: "Partial exemptions",
            text: "Any fund that wants to guarantee a partial exemption of income for its investors must In the future, the fund conditions will stipulate the proportions of shares or real estate shares and provide evidence to the Federal Financial Supervisory Authority (BaFin). According to the legislator, WM Datenservice provides the relevant data. In practice, the <linkText>WM Datenservice<linkText> is unfortunately not able to provide this data.",
            text2:
              "For this reason, we carry out a pre-classification based on internal data and the input of other Rentablo users. Therefore, please check the values provided.",
          },
          products: {
            name: "Product",
            category: "Tax Exemption",
            taxableAmount: "Tax-Relevant Amount",
            success: "The exemption was updated successfully",
          },
        },
      },
      form: {
        breadcrumbs: {
          home: "Home",
          contacts: "Contacts",
          editContact: "Edit",
        },
        required: "Required Field",
        accountData: "Payout information",
        payment: "Payout",
        cancel: "Cancel",
        save: "Save changes",
        recommend: "Send recommendation",
      },
      paymentDataForm: {
        nameWarning:
          "Please contact our support team to change this account holders name",
        payment: "Payout",
        owner: "Account Holder",
        iban: "IBAN",
        bank: "Bank",
        bic: "BIC",
        bankLocation: "Bank location",
        ownerData: "Account holder information",
        lastName: "Last name",
        firstName: "First name",
        ibanError: "This IBAN is invalid. Please verify the given IBAN",
      },
      accountDataForm: {
        title: "Edit account holder",
        accountData: "Payout account data",
        name: "Account holder name",
        type: "Type",
        phone: "Phone / mobile (for further inquiries)",
        address: "Address",
        street: "Street",
        number: "Street number",
        zip: "ZIP",
        city: "City",
        region: "Country",
        anschrift: "Address",
        nameWarning:
          "Please contact our support to change the account holder name",
      },
      contact: {
        owner: "Account Holder",
        edit: "Edit",
        person: "PERSON",
        company: "COMPANY",
        details: "Details",
      },
      invite: {
        breadcrumbs: {
          page: "Recommend Rentablo",
        },
        title: "Recommend {{appName}} Cashback and get {{amount}} € bonus!",
        subtitle: "That’s how it works",
        subtitle2:
          "You may also send an email containing the promotion code right now",
        description:
          "Please send your personal promotion-code to your friend using SMS or WhatsAPP. Your friend may use this code during subscription.",
        myName: "Sender name",
        friendName: "Recipient name",
        email: "Recipient email",
        message: "Message (optional)",
        send: "Send",
        promotion: "Promotion code",
        success: "The email with the code was successfully sent to your friend",
      },
      breadcrumbs: {
        home: "Home",
        cashback: "Cashback",
      },
    },
  },
  questions: {
    INVESTMENT_HORIZON: {
      title: "How long would you like to invest your money?",
      subtitle: "Please select your investment horizon",
      options: {
        LONG_TERM: {
          title: "Long Term Investing",
          subtitle:
            "Investment with an investment horizon of more than 7 years",
        },
        MID_TERM: {
          title: "Medium-Term Investing",
          subtitle: "Investment with an investment horizon of 3 to 7 years",
        },
        SHORT_TERM: {
          title: "Short Term Investing",
          subtitle:
            "Investment with an investment horizon of less than 3 years",
        },
      },
    },
    SUSTAINABILITY: {
      title: "How important is sustainability to you?",
      subtitle: "Please select your preference",
      options: {
        MORE_IMPORTANT: {
          title: "Sustainability is more important to me than return",
          subtitle:
            "Sustainability is a priority, I would too forego higher returns",
        },
        IMPORTANT: {
          title: "Sustainability is important to me",
          subtitle: "Basically important, but not an exclusion criterion",
        },
        LESS_IMPORTANT: {
          title: "Returns are more important to me than sustainability",
          subtitle: " I want a good return, sustainability is secondary",
        },
        NOT_IMPORTANT: { title: "I don't care", subtitle: "No preference" },
      },
    },
    RISK_RETURN_PREFERENCE: {
      title:
        "How would you rate your personal Assess the risk/reward propensity?",
      subtitle: "Choose the option that best applies to you",
      options: {
        NO_RISK: { title: "I don't accept any risk of loss" },
        LOW_RETURN_EXPECTATION: {
          title: "My expected return is low I take small price swings ments.",
        },
        MODERATE_RETURN_EXPECTATION: {
          title:
            "I have a moderate return expectation. In return, I accept a moderate risk of loss due to market fluctuations.",
        },
        HIGH_RETURN_EXPECTATION: {
          title:
            "I expect a high return that is above the capital market interest rate level for as long as possible. In return, I accept the corresponding market fluctuations and higher risk of loss.",
        },
      },
    },
    LIQUID_ASSETS: {
      title: "How high is your amount of liquid assets?",
      subtitle:
        "The details of your assets and liabilities help us to assess your risk-bearing capacity and to determine a maximum investment amount.",
      CASH: "Wie hoch ist Ihr Barvermögen?",
      CASH_placeholder: "Bitte auswählen",
      cashAssetsOptions: {
        UNDER_20K: "Under € 20.000",
        "20K_TO_50K": "€ 20.000 - € 50.000",
        "50K_TO_100K": "€ 50.001 - € 100.000",
        OVER_100K: "Over € 100.000",
      },
      ASSETS_IN_SECURITIES:
        "Wie hoch ist Ihr Vermögen, dass Sie in Wertpapieren angelegt haben?",
      ASSETS_IN_SECURITIES_placeholder: "Bitte auswählen",
      securitiesOptions: {
        UNDER_20K: "Under € 20.000",
        "20K_TO_50K": "€ 20.000 - € 50.000",
        "50K_TO_100K": "€ 50.001 - € 100.000",
        OVER_100K: "Over € 100.000",
      },
    },
    NET_INCOME_AND_NET_EXPENSES: {
      title: "Welche Erfahrungen und Kenntnisse haben Sie mit Fonds und ETF?",
      subtitle:
        "We want to make sure you're comfortable with your investment products, so we ask how experienced you are with specific investments.",
      YEARS_INVESTING_FUNDS:
        "Erfahrung - Seit wie vielen Jahren investieren Sie in das genannte Finanzinstrument?",
      investingYearsOptions: {
        NO_INVEST: "Keine Erfahrung",
        UP_TO_1: "Bis zu 1 Jahr",
        UP_TO_3: "Bis zu 3 Jahren",
        OVER_3: "Mehr als 3 Jahre ",
      },
      KNOWLEDGE_FUNDS:
        "Kenntnisse - Wie vertraut sind Sie mit der Funktionsweise, den Chancen und den Risiken des Finanzinstruments?",
      knowledgeOptions: {
        NO_KNOWLEDGE: "Keine Kenntnisse",
        LOW_KNOWLEDGE: "Wenig Kenntnisse",
        MEDIUM_KNOWLEDGE: "Mittlere Kenntnisse",
        HIGH_KNOWLEDGE: "Viele Kenntnisse",
      },
      TRADES_PER_YEAR_FUNDS: "Durchschnittliche Anzahl Geschäfte / Jahr",
      averageFundTransactionsOptions: {
        "1_TO_4": "0 to 4",
        "5_TO_10": "5 to 10",
        "11_TO_50": "11 to 50",
        OVER_50: "More than 50",
      },
    },
    PREFERENCE_ETF_OR_FUNDS: {
      title: "Do you prefer ETFs or managed funds for your investments?",
      subtitle:
        "We want to make sure that you feel comfortable with your investment products. We therefore ask you about your preferences for certain investments.",
      infoBox: {
        title: "The difference between ETF and mutual fund",
        text: "The goal of traditional investment funds is to outperform an index, while exchange traded funds (ETFs) track the respective indices. Investment funds are actively managed by a fund management, whereas ETFs works without active fund management. Investors have to pay higher fees for active fund management than for passively managed ETFs.",
      },
      options: {
        ETF: {
          title: "ETFs",
          subtitle: "Passive fund management",
        },
        FUNDS: {
          title: "Fonds",
          subtitle: "Active fund management",
        },
        NO_PREFERENCE: {
          title: "Not important",
          subtitle: "No preference",
        },
      },
    },
    age: {
      title: "Wie alt sind Sie?",
      subtitle: "Bitte wählen Sie Ihr Alter aus",
      age: "Alter",
      options: {
        "under-18": "unter 18",
        "18-25": "18 bis 25 Jahre",
        "26-40": "26 bis 40 Jahre",
        "41-60": "41 bis 60 Jahre",
        "over-60": "über 60 Jahre",
      },
    },
    children: {
      title: "Wie viele Kinder haben Sie?",
      subtitle: "Bitte geben Sie die Nummer an",
      children: "Anzahl Kinder",
    },
    income: {
      title: "Wie hoch sind Ihre monatlichen Einnahmen und Ausgaben?",
      subtitle:
        "Bitte machen Sie realistische Angaben damit wir Ihnen die Geldanlage vorschlagen können, die am besten zu Ihnen passt.",
      income: "Monatliche Nettoeinnahmen",
      expenses: "Monatliche Ausgaben",
      options: {
        income: {
          "under-1000": "Under 1.000 euros",
          "1000-1500": "1.000 - 1.500 euros",
          "1501-2500": "1.501 - 2.500 euros",
          "over-2500": "Over 2.500 euros",
        },
        expenses: {
          "under-1000": "Under 1.000 euros",
          "1000-1500": "1.000 - 1.500 euros",
          "1501-2500": "1.501 - 2.500 euros",
          "over-2500": "Over 2.500 euros",
        },
      },
    },
  },
  gaugeChart: {
    risk: "Risk",
    performance: "Perf.",
    riskClass: {
      extremelyLow: "Extremely low",
      veryLow: "Very low",
      low: "Low",
      medium: "Medium",
      high: "High",
      veryHigh: "Very high",
      extremelyHigh: "Extremely high",
      unknown: "Unknown",
    },
    performanceClass: {
      negative: "Negative",
      veryLow: "Very low",
      low: "Low",
      medium: "Medium",
      high: "High",
      veryHigh: "Very high",
      top: "Top",
      unknown: "Unknown",
    },
  },
  performanceTags: {
    title: "Price Development",
    tags: "Tags",
  },
  performanceGauges: {
    risk: "Risk",
    riskClass: "Risk class",
    riskTooltip:
      "Each product is assigned a risk class. The classification into 7 classes is based on volatility. Volatility is given as the annualized standard deviation of daily returns over the available period per strategy.",
    performance: "Performance",
    performanceClass: "Performance class",
    performanceTooltip:
      "Each product is assigned a performance class. The classification into 7 classes is based on annualized return. This is calculated based on historical performance over the available period per strategy.",
    volatility: "Volatility (1Y / 3Y)",
    noData: "N/A",
  },
  performanceNumbers: {
    value: "Value",
    actual: "Actual",
  },
  cashflowAnalyzer: {
    title: "Budget",
    chartTitle: "Income and expenses by category",
    actualMonth: "Actual month",
    mean: "Average",
    income: "Income",
    expenses: "Expenses",
    balance: "Liquid funds",
    monthly: "Monthly",
    quarterly: "Quarterly",
    yearly: "Yearly",
    total: "Total expenses",
    sankeyChart: {
      noExpenses: "Keine Ausgaben",
      revenue: "Einnahmen",
    },
    chartSwitcher: {
      flow: "Flow",
      distribution: "Distribution",
    },
    chart: {
      period: "Period",
    },
    statistic: {
      currentMonth: "Current Month",
      average: "Average",
      revenue: "Revenue",
      expenditure: "Expenditure",
      liquidAssets: "Liquid Assets",
    },
    transactionsTable: {
      title: "Transactions",
      showMore: "Show more transactions",
      noData: "No transactions for the selected period",
      filter: "Filter",
      thisTransactionIs: "This transaction is",
      category: "Category",
      regular: "Regular",
      accountTransfer: "An account transfer",
      account: "Account",
      counterpart: "Counterpart",
    },
    depotsSelector: {
      allAccounts: "All accounts",
      amountAccounts: "{{ selected }} of {{ total }} accounts",
    },
    categoryModal: {
      searchPlaceholder: "Quick Search Category",
      title: "Change Category",
      addCategory: "Add New Category",
      back: "Back",
      save: "Save",
    },
    addCategoryModal: {
      title: "Add New Category",
      main: "Create parent category",
      sub: "Create subcategory",
      mainCategory: "Choose parent category",
      mainCategory_placeholder: "Please select",
      subCategoryName: "Create subcategory",
      subCategoryName_placeholder: "New category",
      mainCategoryName: "Create category",
      mainCategoryName_placeholder: "New Category",
      created: "Category was created successfully",
      deleted: "Category was deleted successfully",
      assigned: "Category was assigned successfully",
    },
  },
  contractAdminPage: {
    title: "Provider Name",
    breadcrumb: "Provider Name",
    searchLabel: "Here you can search for provider names",
    searchPlaceholder: "Enter name",
    table: {
      name: "Name",
      iban: "Iban",
      category: "Category",
      subCategory: "Sub-category",
      popularity: "Popularity",
      status: "Status",
      date: "Date",
      done: "Done",
    },
    buttonText: "Done",
    tooltip: {
      userSuggestions: "User suggestions for provider name",
      edit: "Edit",
    },
    noData: "No classification data available",
    modal: {
      title: "Mark this entry as completed?",
      subtitle: "This action cannot be undone.",
      cancelButton: "No",
      confirmButton: "Yes",
      success: "Entry completed successfully.",
      error: "Something went wrong. Please try again later",
    },
  },
  settings: {
    changesSaved: "Changes saved",
    errorOccurred: "An error has occurred",
    sidebar: {
      title: "Settings",
      common: {
        title: "General",
        profile: "Profile",
        notifications: "Notifications",
        premium: "Premium Packages",
        advanced: "Bank Import Settings",
      },
      bankConnections: {
        title: "Bank Connections",
        noAccountsTooltip:
          "No accounts or depots exist for this bank connection. Before rebuilding the bank connection, please first delete the existing bank connection. This will prevent potential problems when importing accounts or depots.",
      },
      twoFA: {
        title: "Security settings",
      },
      userId: {
        label: "USER ID",
        tooltip:
          "This is your UserID. You need this ID e.g. for support requests or to connect with KICS.",
      },
    },
    twoFA: {
      title: "Security settings",
      subtitle: "Two-factor authentication",
      codeLabel: "Enter code",
      methods: {
        title: "Your 2FA method",
        subtitle:
          "Two-factor authentication generates a unique, temporarily valid security code for each login attempt. The following overview suggests suitable apps.",
        googleAuth: "Google Authenticator",
        microsoftAuth: "Microsoft Authenticator",
        linkForAndroid: "Link for Android",
        linkForApple: "Link for Apple",
      },
      disabled: {
        description:
          "Protect your account by enabling two-factor authentication (2FA). To set it up, an authenticator app is required (see options below).",
        toggle: "Enable two-factor authentication",
      },
      enabled: {
        description:
          "Your account is protected by two-factor authentication (2FA).",
        description1:
          "To disable two-factor authentication, use the toggle and enter the provided one-time code.",
        toggle: "Disable two-factor authentication",
      },
      setup: {
        step1: {
          title: "Step 1 – Secure your account",
          subtitle:
            "Scan the QR code below with your preferred authenticator app and then enter the generated one-time code below.",
        },
        step2: {
          title: "Step 2",
          subtitle: "Enter the two-factor verification code.",
        },
        confirmButton: "Enable 2FA",
      },
      disable: {
        description: "Enter the two-factor verification code.",
        disableButton: "Disable 2FA",
      },
      messages: {
        error: "Something went wrong. Please try again",
        qrLoadError: "The QR code could not be loaded. Please try again.",
        invalidCodeError: "Invalid or expired code. Please try again.",
        disableSuccess: {
          title: "Two-factor authentication",
          text: "Two-factor authentication for your account has been disabled.",
        },
        enableSuccess: {
          title: "Two-factor authentication",
          text: "Two-factor authentication has been enabled.",
        },
      },
    },
    profile: {
      title: "Your User Profile",
      subtitle: "Customize Your User Information",
      avatar: {
        title: "Avatar Avatar",
        upload: " Upload avatar",
        replace: "Replace avatar",
        delete: "Delete",
        info: "We support PNGs, JPEGs with a file size below 10MB.",
      },
      form: {
        gender: "Salutation",
        academicTitle: "Title",
        firstName: "First name",
        lastName: "Last name",
        email: "Email address",
        oldEmail: "Current email address",
        newEmail: "New email address",
        newEmail_placeholder: "Your new email address",
        newEmailConfirmation: "New email address repeat",
        newEmailConfirmation_placeholder: "Your new email address",
        oldPassword: "Current password",
        forgotPassword: "Forgot your password",
        oldPassword_placeholder: "Please enter your current password",
        newPassword: "Set new password",
        newPassword_placeholder: "Please set a password...",
      },
      emailEditLink: "Change email address",
      passwordEditLink: "Change password",
      emailEditModal: {
        title: "Change email",
        subtitle: "Enter your new email address",
        close: "Close",
        submit: "Change email address",
        success:
          "We have sent a confirmation email to <strongText>{{email}}</strongText>. Your old email address will remain valid until confirmed.",
      },
      passwordEditModal: {
        title: "Change Password",
        subtitle: "Enter your new password",
        close: "Cancel",
        submit: "Change Password",
        success: "Your password was successfully changed",
        forgotPassword: "Forgot your password",
        error: "Something went wrong. Please try again",
      },
      emailChangeSuccess: "Email address changed",
      emailChangeError:
        "Email address could not be changed. Please contact our support.",
    },
    notifications: {
      title: "Notifications",
      subtitle: "Customize your notifications",
      banner: {
        title: "All notifications disabled",
        subtitle: "You are currently not receiving any notifications",
      },
      form: {
        investmentReportFrequency: "Investment Report",
        investmentReportFrequency_weekly: "Weekly",
        investmentReportFrequency_monthly: "Monthly",
        investmentReportFrequency_never: "Never",
        emailNotification: "Automatic notification of portfolio updates ",
        emailNotification_yes: "Yes",
        emailNotification_no: "No",
      },
      newsLetters: {
        title: "Manage Rentablo newsletter",
        description:
          "The rentablo.de newsletter informs about new features and interesting blog entries. We will limit ourselves to relevant information. We deliberately keep the frequency low so as not to fill up your inbox unnecessarily.",
        subscribe: "Subscribe to newsletter",
        unsubscribe: "Unsubscribe from newsletter",
      },
    },
    advanced: {
      title: "Advanced",
      subtitle: "Customize the advanced features that affect your account",
      bankImport: { title: "Bank import connection settings" },
      deleteConnection: {
        title: "Delete all finAPI bank connection data",
        text: "Delete all of your data stored at <linkText>finAPI<linkText> . Data that has already been imported is retained. It is then no longer possible to synchronize your depots and accounts.",
        info: "If you only want to delete a saved PIN, please do so here in the account management",
        buttonText: "Delete bank data",
        deleteConnectionConfirmModal: {
          title: " Are you sure?",
          text: "If you delete your bank details, there will no longer be an automatic depot and account update.",
          cancel: "Cancel",
          confirm: "Delete connection",
        },
      },
      tracking: {
        title: "Tracking",
        text: "Help us to improve {{appName}} through statistics on website usage and user behavior. The data will only be used to improve our website.",
        buttonTextOff: "Revoke consent",
        buttonTextOn: "Give consent",
      },
      deleteAccount: {
        title: "Close {{appName}} Account Permanently",
        text: "Your {{appName}} is hereby closed accounts. Your data will be irrevocably deleted as a result. Access to your account is no longer possible after the closure.",
        info: "This process cannot be undone!",
        buttonText: "Delete {{appName}} Account",
        deleteAccountConfirmModal: {
          title: "Are you sure?",
          text: "Your account will be closed and all data will be irrevocably deleted. Further access is then no longer possible.",
          cancel: "Cancel",
          confirm: "Delete account",
          success: "Your account has been successfully deleted",
        },
      },
      deletePortalAccount: {
        title: "Permanently delete account",
        note: "Deleting your account will permanently remove all data. Access to <bold>{{portalName}}</bold> will no longer be possible.",
        buttonText: "Delete account",
      },
    },
    bankConnection: {
      subtitle: "Manage accounts and custody accounts",
      accounts: {
        title: "Accounts",
        menu: {
          deleteSavedPins: "Delete Saved Pins",
          deleteBankDetails: "Delete Bank Details",
        },
      },
      accountTypes: {
        1: "Girokonto",
        2: "Sparkonto",
        3: "Kreditkarte",
        4: "Depot",
        5: "Darlehenskonto",
        6: "Girokonto",
        7: "Mitgliedschaft",
        8: "Bausparen",
        21: "Verrechnungskonto",
        22: "Währungskonto",
        "01_depot": "Depot",
        "02_cash": "Girokonto",
      },
      deletePinsModal: {
        title: "Are you sure?",
        text: "The next time you update your securities depot account, {{appName}} will ask for your new banking PIN.",
        cancel: "Cancel",
        submit: "Delete Pins",
        error: "Something went wrong. Please try again later",
        success: "Pins were successfullly deleted",
      },
      deleteBankConnectionModal: {
        title: "Are you sure?",
        text: "If you delete your bank details, the automatic portfolio and account update will no longer take place.",
        cancel: "Cancel",
        submit: "Delete connection",
        error: "Something went wrong. Please try again later",
        success: "Connection was successfully deleted",
      },
      interfaces: {
        title: "Interfaces",
        active: "Active",
        info: "{{appName}} enables access to around 3,500 bank connections. The corresponding interfaces (API) are primarily provided by our partner finAPI. In addition, {{appName}} has connected some banks and brokers itself via direct API. These include comdirect, Trade Republic, Whitebox, Quirion and Scalabe.",
        actualized: "Updated",
      },
    },
  },
  components: {
    depotSelect: {
      label: "Select depot or accounts",
      noOptions: "No depots or accounts found",
      loading: "Loading depots and accounts...",
      types: {
        "01_depot": "DEPOTS",
        "02_cash": "ACCOUNTS",
      },
      modal: {
        title: "Create new depot",
        name: "Depot name",
        name_placeholder: "Depot name",
        save: "Create",
      },
    },
    depotsStatistic: {
      showHistoricSwitch: "Show historic",
      tabs: {
        export: "Export CSV",
        investments: "Investments",
        bookings: "Bookings",
      },
      bookingsTable: {
        noItems: "There are no bookings",
        headers: {
          investmentType: "Investment",
          name: "Name",
          price: "Price",
          amount: "Amount",
        },
        lots: "Pc.",
      },
      chart: {
        subheader: {
          performance: "Total value:",
          valuation: "Valuation:",
        },
        typeSwitcher: {
          performance: "Performance",
          valuation: "Valuation",
        },
      },
    },
    AssetTypeCard: {
      ytd: "YTD",
    },
    quotes: {
      quoteChartContainer: {
        subheader: "Current value",
      },
    },
    layouts: {
      showcaseLayout: {
        imageAlt: "{{appName}} Logo",
      },
    },
  },
  aboutCompany: {
    support: {
      phone: "(0) 30 - 71 53 30 10",
      phoneLink: "+03071533010",
      phoneInfo: "Available Monday to Friday from 9 a.m. to 6 p.m.",
      email: "{{supportEmail}}",
    },
    company: {
      name: "{{appName}}, eine Marke der wealthAPI GmbH",
      street: "Fanny-Zobel-Str.",
      streetNumber: "9",
      zip: "12435",
      city: "Berlin",
      claim: "Das kostenfreie Tool für Ihren Finanzerfolg",
    },
    brand: {
      name: "{{appName}}",
    },
    media: {
      email: "presse@bn.de",
      b2bEmail: "presse@wealthapi.eu",
    },
    b2b: {
      name: "wealthAPI GmbH",
      claim: "Smart Financial Decisions",
      email: "info@wealthapi.eu",
      privacyEmail: "datenschutz@wealthapi.eu",
      website: "https://wealthapi.eu",
    },
  },
  docs: {
    agb: {
      title: "Allgemeine Geschäftsbedingungen (AGB)",
    },
    disclaimer: {
      title: "Haftungsausschluss",
    },
    impressum: {
      title: "Impressum",
    },
    privacy: {
      title: "Datenschutz",
    },
  },
  feedbackGlobalButton: {
    tooltip: "Feedback",
  },
  navigation: {
    cancel: "Cancel",
    previous: "Previous",
    next: "Next",
    save: "Save",
    deleteModal: {
      errorTitle: "Error",
      confirmTitle: "Confirm delete?",
      yes: "Yes",
      no: "No",
      close: "Close",
      cannotBeUndone: "This action cannot be undone",
    },
  },
  somethingWrong: {
    loginFailed: "Login failed, please check your email and password",
    shortTitle: "Sorry, something went wrong.",
    subTitle:
      "Try again. Please contact our support using {{supportEmail}} if this problem persist.",
    title:
      "Sorry, something went wrong. Try again. Please contact our support using {{supportEmail}} if this problem persist.",
    message: "{{message}}.",
    eventIdMessage: "The error ID is: {{eventId}}",
    reload: "Reload",
  },
  company: {
    name: "{{appName}} GmbH",
    customerService: "Kundenservice",
    street: "Fanny-Zobel-Straße 9",
    zip: "12435",
    city: "Berlin",
  },
  cashback: {
    50: "Cashback-50",
    100: "Cashback-100",
    "50upTo": "up to 75.000 €",
    "100from": "from 75.000 €",
  },
  terms: {
    agb: "Terms of use",
    impressum: "Impressum",
  },
  ranges: {
    years: {
      oneYear: "1 Year",
      threeYears: "3 Years",
      fiveYears: "5 Years",
      tenYears: "10 Years",
    },
    max: "Max",
  },
  accountTypes: {
    "01_depot": "Depot",
    "02_cash": "Accounts",
    "04_insurance": "Insurance",
    "05_material_assets": "Precious metals and tangible assets",
    bankSelect: {
      label: "Bank Name, BIC or IBAN",
      noOptions: "No options",
      bankName: "Bank name",
      bic: "BIC",
    },
  },
  bookingTypes: {
    buy: "Buy",
    sell: "Sell",
    dividend: "Dividend",
    book_in: "Book-in",
    book_out: "Book-out",
    split: "Split",
    reverse_split: "Reverse split",
    retained_dividend: "Retained dividend",
    purchase_right: "Purchase right",
    carve_out: "Carve-out",
    pre_tax_allowance: "Tax-free allowance",
    switch: "Switch",
    cap_gains_tax: "Capital gains tax",
    cap_gains_tax_refund: "Capital gains tax refund",
    fees: "Fees",
  },
  investmentTypes: {
    "11_stock": "Stock",
    "21_fund": "Fund",
    "22_etf": "ETF",
    "31_bond": "Bond",
    "51_certos": "Certificate / OS",
    "61_pmetals": "Precious metal",
    "71_massets": "Material Asset",
    "81_fcurr": "Foreign currency",
    "91_managed": "Robo / Managed depot",
    "92_other": "Other",
  },
  quantities: {
    pieces: "lots",
    percent: "per cent",
  },
  signupWizard: {
    restoreWizardDialog: {
      title: "You have a booking in progress. Would you like to continue?",
      contentText: "You can have only one booking in progress in a time.",
      continueButton: "Continue",
      startNewButton: "Start new",
    },
    validation: {
      isNotEmpty: "is required",
      isNotEmptyArray: "must not be empty",
      isPhoneNumber: "phone number is invalid",
      isPassword: "password must have at least 8 characters",
      isAgbAccepted: "you must accept agb",
      isEmail: "email is invalid",
      isPayoutBank: "Given IBAN is not correct",
      isComdirectCustomerNumber: "must be 10 numbers (0-9)",
      isEbaseDepotNumber: "must be 10 or 11 numbers (0-9)",
      isDabAccountNumber: "must be 7 numbers (0-9)",
      isAugsburgerAktienbankDepotNumber: "must be 10 numbers (0-9)",
      isDwsDepotNumber: "starting with letter and 7 numbers",
      isFfbDepotNumber: "must be 10 numbers (0-9)",
      isFondsdepotDepotNumber: "must be 9 or 10 numbers (0-9)",
      isMetzlerDepotNumber: "must be 10 numbers (0-9)",
      isStreetWithNumber: "is required",
    },
    cashbackProcessIntroduction: {
      heading: "That's how it works:",
      enterData: "Enter Data",
      print: "Print",
      sendToUs: "Send to us",
      youRequire:
        "You require: About <1>5 minutes</1> together with your account or customer ID in case you are already a customer of one of our partner banks.",
      startNow: "Start now",
      thatIsHowWeCalculateCashback: "That is how we calculate your cashback",
      depotSize: "Depot size",
      bestPriceGuarantee:
        "<0>Best-Price Guarantee:</0> we automatically select the cashback model that fits you best",
      onceForAllYourDepots: "no matter how many depots you have",
      discountOnAgio: "Agio discount",
      cost: "Cost",
      noCost: "None",
      youReceive: "Your cashback",
      "50percentCashback": "50 % of the portfolio commission",
      "100percentCashback": "up to 100 % of the portfolio commission",
      administrationFee: "15 € / month",
      administrationFeeDetails: "(offset against Cashback)",
      rentabloReceives: "Rentablo receives",
      moreAssetsMoreCashback: "Receive up to 100% Cashback",
      seeIllustration: "See interactive chart",
    },
    cashbackSummary: {
      heading: "Print PDF form now",
      printOutNote:
        "Your Cashback form has been generated and are available for download.",
      printedOutQuestion: "Printed out?",
      foundAMistake: "Found a mistake",
      correctDataButton: "Change data",
      print: "Print here",
      printPdf: "Print forms",
      nextStepsButton: "That's next",
      wouldYouLikeToCorrectYourData: "Would you like to correct your data?",
    },
    cashbackNextSteps: {
      heading: "Perfect, almost done!",
      reviewForms: "Please review the generated forms.",
      printOutAndSign:
        "Now <1>please sign the printed out documents</1> and send it to us!",
      sendBack: "Send document",
      sendBackDescription: "A return-cover is included in your documents.",
      identifyViaPostident: "and <1>identify using PostIdent</1>",
      identifyViaPostidentDescription:
        "The PostIdent form is included in the generated documents.",
      identifyViaRentablo: "and <1>include a copy of your ID card</1>",
      identifyViaRentabloDescription:
        "To open the depot, our staff will identify you. We will contact you after receiving your documents.",
      birthCertificate: "Include a <1>Certificate of birth</1>",
      birthCertificateDescription:
        "Please include the minors certificate of birth, which is required by the bank.",
      allDone: "All done!",
      backButton: "Back to subscription",
      addAnotherDepot: "Add another depot",
      altExit: "or",
      backToMainPage: "Back to overview",
    },
    cashbackNextStepsForCompany: {
      heading: "Perfect, the next steps are...",
      dataReceived: "We received your request for opening a depot",
      weWillContactYou: "We will contact you shortly",
      weWillContactYouDescription:
        "Unfortunately, banks frequently change the process to open a company depot. One ouf our employees will contact you shortly and support you with the steps required to open your companies depot.",
      contactUs:
        "Should you not hear from us within the next working day, please do not hesitate to contact us via Email to <1>{{supportEmail}}</1> or give us a call under <1>030 - 71533009</1>.",
    },
    selectNewOrExistingDepotStep: {
      naturalPerson: "Private customer",
      legalPerson: "Legal Person (UG / GmbH / AG / Foundation)",
      newDepot: "Open new depot",
      newCompanyDepot: "Open new depot for company",
      existingDepot: "I have an existing depot",
      existingCompanyDepot: "I have an existing depot for my company",
      question: "Please select an option:",
    },
    companyDepotTermsStep: {
      question: "Note: Terms for company depots",
      terms:
        "Company depots are pretty distinct from private customer depots in terms of size and administration effort. For this reason, your cashback will be <1>80 % overall</1> of portfolio commission received by Rentablo.",
      oneClick:
        "On top, you will have free access to the Rentablo One-Click Import to easily manage your portfolio.",
    },
    selectBankStep: {
      question: "At which bank would you like to open a depot?",
      onvistaQuestion:
        "At which partner bank would you like to open an onvista-cashback depot?",
      recommendedBankHeading:
        "Due to their excellent service and our positive experience we recommend comdirect bank",
    },
    selectRecommendedBankStep: {
      question: "At which bank would you like to open a depot?",
      recommendedBankHeading:
        "Due to their excellent service and our positive experience we recommend comdirect bank",
    },
    selectExistingDepotStep: {
      question: "Which of the Rentablo partner banks is managing your depot?",
      noDepotYet: "No depot at a Rentablo partner bank as of yet?",
      openDepot: "Open depot now.",
    },
    emailStep: {
      question: "What's your email?",
      placeholder: "Email",
    },
    passwordStep: {
      question: "Type secure password",
      placeholder: "Password",
    },
    acceptTermsAndConditionsStep: {
      question: "Please accept terms and conditions",
      agb: "With the registration I accept the <1>terms and conditions</1> and <3>data protection regulations</3>*",
      newsLetters:
        "I would like to be informed about new functions and savings offers",
      accountCreationFailed:
        "Sorry, but we could not create a user for the following reason:",
      pleaseLogin:
        "In case you you used this email address before, please <1>Login to your Rentablo account</1>",
    },
    selectAccountHolderTypeStep: {
      questionNewDepot: "Which type of account would you like to open?",
      questionAdvisorChange:
        "Which kind of account would you like to transfer?",
      single: "Single",
      joined: "Joined",
      minor: "Minor (with legal custodians)",
    },
    // Natural person
    summaryStep: {
      takeoverData: "Yes, continue",
      editData: "No, edit data",
    },
    personalInformationSummaryStep: {
      question: "Is account holder's personal data correct?",
      questionPartner: "Is your partners personal data correct?",
      questionMinor: "Is the minors personal data correct?",
      questionLegalGuardian1:
        "Is the first legal guardians personal data correct?",
      questionLegalGuardian2:
        "Is the second legal guardians personal data correct?",
      questionCompany: "I the companies' data correct?",
      gender: "Gender",
      firstName: "First name",
      lastName: "Last name",
      nameAtBirth: "Name at birth",
      dateOfBirth: "Date of birth",
      placeOfBirth: "Place of birth",
      countryOfBirth: "Country of birth",
      street: "Street",
      houseNumber: "Street number",
      zip: "ZIP",
      city: "City",
      addressCountry: "Country",
    },
    companyInformationSummaryStep: {
      question: "Are the company data correct?",
      salutation: "Salutation",
      companyName: "Company name",
      legalForm: "Legal form",
      street: "Street",
      houseNumber: "Street number",
      zip: "ZIP",
      city: "City",
      addressCountry: "Country",
    },
    payoutSummaryStep: {
      question: "Is the Cashback payout information correct?",
      bankNameWithBic: "Bank",
      iban: "IBAN",
      payoutAccountFirstName: "Holders first name",
      payoutAccountLastName: "Holders last name",
    },
    mifidSummaryStep: {
      question: "Is your MIFID data correct",
      questionPartner: "Is your partners MIFID data correct?",
      questionMinor: "Is the minors MIFID data correct?",
      questionLegalGuardian1:
        "Is the first legal guardians MIFID data correct?",
      questionLegalGuardian2:
        "Is the second legal guardians MIFID data correct?",
      mifidOccupationGroup: "Occupational group",
      mifidOccupation: "Occupation",
      mifidSector: "Sector",
      mifidCountryOfWork: "Country of work",
      mifidAccessToInsiderInfo: "Access to insider information",
      yes: "Yes",
      no: "No",
      mifidAnnualIncome: "Annual income",
      mifidLiquidAssets: "Liquid Assets",
    },
    investmentExperienceSummaryStep: {
      question: "Is your investment experience correct?",
      0: "not provided",
      1: "less than a year",
      2: "more than a year",
      3: "more than two years",
      experienceCertificatesAndOptionsWithLeverage:
        "Certificates and options with leverage",
      experienceCertificatesAndOptionsWithoutLeverage:
        "Certificates and options without leverage",
      experienceDomesticBonds: "Domestic bonds",
      experienceDomesticStocks: "Domestic stocks",
      experienceForeignCurrency:
        "Foreign currency investments (excluding futures)",
      experienceForeignStocks: "Foreign stocks",
      experienceFunds: "Investment funds (issues residing outside of the EU)",
      experienceOther: "Other futures or products with leverage",
      experienceForeignBonds:
        "Bonds emitted by foreign issuers or in foreign currency",
    },
    taxationSummaryStep: {
      question: "Is your taxation data correct",
      questionPartner: "Is your partners taxation data correct?",
      questionMinor: "Is the minors taxation data correct?",
      questionLegalGuardian1:
        "Is the first legal guardians taxation data correct?",
      questionLegalGuardian2:
        "Is the second legal guardians taxation data correct?",
      taxationCountry1: "Tax residence",
      taxationNumber1: "Tax ID",
      taxationCountry2: "Additional tax residence",
      taxationNumber2: "Additional Tax ID",
      taxationCountry3: "Additional tax residence",
      taxationNumber3: "Additional Tax ID",
      taxationUsTaxLiability: "US tax liability",
      taxationUsTaxNumber: "US tax ID",
      yes: "Yes",
      no: "No",
    },
    selectGenderStep: {
      question: "What is your gender?",
      questionPartner: "What is the gender of your partner?",
      questionMinor: "What is the gender of the minor?",
      questionLegalGuardian1: "What is the gender of the first legal guardian?",
      questionLegalGuardian2:
        "What is the gender of the second legal guardian?",
      questionCompany: "What is your salutation?",
      male: "male",
      female: "female",
      salutation: "Salutation",
    },
    hasSecondLegalGuardianStep: {
      question: "Is there a second legal guardian?",
      single: "Single parent",
      joined: "Add a second legal guardian",
    },
    firstNameStep: {
      question: "What is your first name?",
      questionPartner: "What is your partners first name?",
      questionMinor: "What is the minors first name?",
      questionLegalGuardian1: "First name of the first legal guardian",
      questionLegalGuardian2: "First name of the second legal guardian",
      questionCompany: "What is the company name",
      placeholder: "First name",
      companyplaceholder: "Company name",
    },
    lastNameStep: {
      question: "What is your last name?",
      questionPartner: "What is your partners last name?",
      questionMinor: "What is the minors last name?",
      questionLegalGuardian1: "Last name of the first legal guardian",
      questionLegalGuardian2: "Last name of the second legal guardian",
      questionCompany: "Legal form (GmbH / UG, ...)",
      placeholder: "Last name",
      companyplaceholder: "Legal form",
    },
    countryOfBirthStep: {
      question: "In which country were you born?",
      questionPartner: "In which country was your partner born?",
      questionMinor: "In which country was the minor born?",
      questionLegalGuardian1:
        "In which country was the first legal guardian born?",
      questionLegalGuardian2:
        "In which country was the second legal guardian born?",
      placeholder: "Please select a country",
    },
    placeOfBirthStep: {
      question: "What is your place of birth?",
      questionPartner: "What is your partners place of birth?",
      questionMinor: "What is the minors place of birth?",
      questionLegalGuardian1:
        "What is the first legal guardians place of birth?",
      questionLegalGuardian2:
        "What is the second legal guardians place of birth?",
      placeholder: "Place of birth",
    },
    nameAtBirthStep: {
      question: "What is your maiden name?",
      questionPartner: "What is your partners maiden name?",
      questionMinor: "What is the minors maiden name?",
      questionLegalGuardian1: "What is the first legal guardians maiden name?",
      questionLegalGuardian2: "What is the second legal guardians maiden name?",
      placeholder: "Name of birth",
    },
    dateOfBirthStep: {
      question: "When were you born?",
      questionPartner: "When was your your partner born?",
      questionMinor: "When was the minor born?",
      questionLegalGuardian1: "When was the first legal guardian born?",
      questionLegalGuardian2: "When was the second legal guardian born?",
      placeholder: "Date of birth",
      label: "Date of birth",
    },
    addressStep: {
      question: "Address: What is your street?",
      questionPartner: "Address: What is your partners street?",
      questionMinor: "Address: what is the minors street?",
      questionLegalGuardian1:
        "Address: What is the first legal guardians street?",
      questionLegalGuardian2:
        "Address: What is the second legal guardians street?",
      questionCompany: "Registered office: street",
      placeholder: "Street",
      placeholderHouseNumber: "house number",
    },
    zipStep: {
      question: "Address: What is your ZIP?",
      questionPartner: "Address: what is your partners ZIP?",
      questionMinor: "Address: what is the minors ZIP?",
      questionLegalGuardian1: "Address: What is the first legal guardians ZIP?",
      questionLegalGuardian2:
        "Address: What is the second legal guardians ZIP?",
      questionCompany: "Registered office: ZIP",
      placeholder: "ZIP",
    },
    cityStep: {
      question: "Address: In which city do you live?",
      questionPartner: "Address: In which city does your partner live?",
      questionMinor: "Address: In which city does the minor live?",
      questionLegalGuardian1:
        "Address: In which city does the first legal guardians live?",
      questionLegalGuardian2:
        "Address: In which city does the second legal guardians live?",
      questionCompany: "Registered office: city",
      placeholder: "City",
    },
    addressCountryStep: {
      question: "Address: In which country do you live?",
      questionPartner: "Address: In which country does your partner live?",
      questionMinor: "Address: In which country does the minor live?",
      questionLegalGuardian1:
        "Address: In which country does the first legal guardian live?",
      questionLegalGuardian2:
        "Address: In which country does the second legal guardian live?",
      questionCompany: "Registered office: country",
      placeholder: "Country",
    },
    occupationalGroupStep: {
      question: "What is your occupation group?",
      questionPartner: "What is the occupation group of your partner?",
      questionMinor: "What is the minors occupation group?",
      questionLegalGuardian1:
        "What is the first legal guardians occupation group?",
      questionLegalGuardian2:
        "What is the second legal guardians occupation group?",
      placeholder: "Occupation group",
    },
    occupationStep: {
      question: "What is your occupation?",
      questionPartner: "What is your partners occupation?",
      questionMinor: "What is the minors occupation?",
      questionLegalGuardian1: "What is the first legal guardians occupation?",
      questionLegalGuardian2: "What is the second legal guardians occupation?",
      placeholder: "Occupation",
    },
    sectorStep: {
      question: "In which sector do you work?",
      questionPartner: "In which sector does your partner work?",
      questionMinor: "In which sector does the minor work?",
      questionLegalGuardian1:
        "In which sector does the first legal guardian work?",
      questionLegalGuardian2:
        "In which sector does the second legal guardian work?",
      placeholder: "Occupational sector",
    },
    countryOfWorkStep: {
      question: "In which country do you work?",
      questionPartner: "In which country does your partner work?",
      questionMinor: "In which country does the minor work?",
      questionLegalGuardian1:
        "In which country does the first legal guardian work?",
      questionLegalGuardian2:
        "In which country does the second legal guardian work?",
      placeholder: "Please select a country",
    },
    accessToInsiderInfoStep: {
      question: "Do you have access to insider information?",
      questionPartner: "Does your partner have access to insider information?",
      questionMinor: "Does the minor have access to insider information?",
      questionLegalGuardian1:
        "Does the first legal guardian have access to insider information?",
      questionLegalGuardian2:
        "Does the second legal guardian have access to insider information?",
      yes: "yes",
      no: "no",
    },
    annualIncomeStep: {
      question: "What is your annual income?",
      questionPartner: "What is the annual income of your partner?",
      questionMinor: "What is the annual income of the minor?",
      questionLegalGuardian1: "What is the first legal guardians annual income",
      questionLegalGuardian2:
        "What is the second legal guardians annual income",
      placeholder: "Income",
    },
    liquidAssetsStep: {
      question: "What is your fortune (liquid assets)?",
      questionPartner: "What is your partners fortune (liquid assets)?",
      questionMinor: "What is the minors fortune (liquid assets)?",
      questionLegalGuardian1:
        "What is the first legal guardians fortune (liquid assets)?",
      questionLegalGuardian2:
        "What is the second legal guardians fortune (liquid assets)?",
      placeholder: "Liquid assets",
    },
    countryOfNationalityStep: {
      questionPrimary: "What is your nationality?",
      questionSecondary: "What is your secondary nationality?",
      questionPartnerPrimary: "What is your partners nationality?",
      questionPartnerSecondary: "What is your partners secondary nationality?",
      questionMinorPrimary: "What is the minors nationality?",
      questionMinorSecondary: "What is the minors secondary nationality?",
      questionLegalGuardian1Primary:
        "What is the first legal guardians nationality?",
      questionLegalGuardian1Secondary:
        "What is the first legal guardians secondary nationality?",
      questionLegalGuardian2Primary:
        "What is the second legal guardians nationality?",
      questionLegalGuardian2Secondary:
        "What is the second legal guardians secondary nationality?",
      placeholder: "Please select a country",
    },
    anotherNationalityStep: {
      question: "Do you have another nationality?",
      questionPartner: "Does your partner have another nationality?",
      questionMinor: "Does the minor have another nationality?",
      questionLegalGuardian1:
        "Does the first legal guardian have another nationality?",
      questionLegalGuardian2:
        "Does the second legal guardian have another nationality?",
      yes: "yes",
      no: "no",
    },
    npNationalIdentifierStep: {
      questionPrimary: "What is your national identifier?",
      questionSecondary:
        "What is your national identifier (second nationality)?",
      questionPartnerPrimary: "What is your partners national identifier?",
      questionPartnerSecondary:
        "What is your partners national identifier (second nationality)?",
      questionMinorPrimary: "What is the minors national identifier?",
      questionMinorSecondary:
        "What is the minors national identifier (second nationality)?",
      questionLegalGuardian1Primary:
        "What is the first legal guardians national identifier?",
      questionLegalGuardian1Secondary:
        "What is the first legal guardians national identifier (second nationality)?",
      questionLegalGuardian2Primary:
        "What is the second legal guardians national identifier?",
      questionLegalGuardian2Secondary:
        "What is the second legal guardians national identifier (second nationality)?",
      placeholder: "National identifier",
    },
    countryOfTaxationStep: {
      question: "What is your tax residence?",
      questionPartner: "What is your partners tax residence?",
      questionMinor: "What is the minors tax residence?",
      questionLegalGuardian1:
        "What is the first legal guardians tax residence?",
      questionLegalGuardian2:
        "What is the second legal guardians tax residence?",
      placeholder: "Select a country",
    },
    taxNumberStep: {
      question: "What is your tax number?",
      questionPartner: "What is your partners tax number?",
      questionMinor: "What is the minors tax number?",
      questionLegalGuardian1: "What is the first legal guardians tax number?",
      questionLegalGuardian2: "What is the second legal guardians tax number?",
      placeholder: "Tax number",
    },
    usTaxLiabilityStep: {
      question: "Are you liable for taxation in the US?",
      questionPartner: "Is your partner liable for taxation in the US?",
      questionMinor: "Is the minor liable for taxation in the US?",
      questionLegalGuardian1:
        "Is the first legal guardian liable for taxation in the US?",
      questionLegalGuardian2:
        "Is the second legal guardian liable for taxation in the US?",
      yes: "yes",
      no: "no",
    },
    npTaxationOneMoreStep: {
      question: "Are your liable for taxation in another country?",
      questionPartner:
        "Is your partner liable for taxation in another country?",
      questionMinor: "Is the minor liable for taxation in another country?",
      questionLegalGuardian1:
        "Is the first legal guardian liable for taxation in another country?",
      questionLegalGuardian2:
        "Is the second legal guardian liable for taxation in another country?",
      yes: "yes",
      no: "no",
    },
    investmentExperienceStep: {
      pleaseSelectOption: "please select",
      lessThanYearOption: "less than a year",
      moreThanYearOption: "more than a year",
      moreThanTwoYearsOption: "more than two years",
    },
    experienceCertificatesAndOptionsWithLeverageStep: {
      question:
        "What is your experience with certificates and options with leverage",
    },
    experienceCertificatesAndOptionsWithoutLeverageStep: {
      question:
        "What is your experience with certificates and options without leverage",
    },
    experienceDomesticBondsStep: {
      question: "What is your experience with domestic bonds",
    },
    experienceDomesticStocksStep: {
      question: "What is your experience with domestic stocks",
    },
    experienceForeignCurrencyStep: {
      question: "What is your experience with foreign currency",
    },
    experienceForeignStocksStep: {
      question: "What is your experience with foreign stocks",
    },
    experienceFundsStep: {
      question: "What is your experience with funds",
    },
    experienceOtherStep: {
      question: "What is your experience with other investments",
    },
    experienceForeignBondsStep: {
      question: "What is your experience with foreign bonds",
    },
    comdirectConditionModelStep: {
      question: "Which conditions model do you prefer?",
      subtitle: "Hint: you may change your conditions model at any time.",
      conditionModel3: 'Model "Flatfee"',
      conditionModel3Description:
        "The conditions model for large depots <1>from 8.000 €</1> <2>per Order</2>",
      conditionModel3DescriptionDetails:
        "Flat-fee of 19,95 € for orders / XETRA / bonds and sells",
      conditionModel5: 'Model "Standard"',
      conditionModel5Description:
        "The standard conditions model for depots <1>up to 8.000 €</1> <2>per Order</2>",
      conditionModel5DescriptionDetails:
        "0,25% of the order volume (min. 10,00 €, max. 90,00 €)",
    },
    dabConditionModelStep: {
      question: "Which conditions model do you prefer?",
      subtitle: "Hint: you may change your conditions model at any time.",
      conditionModel1228: 'Model "Flatfee"',
      conditionModel1228Description:
        "The conditions model for large depots <1>from 6.000 €</1> <2>per Order</2>",
      conditionModel1228DescriptionDetails:
        "Flat-fee of 15,00 € for orders / XETRA / bonds and sells",
      conditionModel1139: 'Model "Standard"',
      conditionModel1139Description:
        "The standard conditions model for depots <1>up to 6.000 €</1> <2>per Order</2>",
      conditionModel1139DescriptionDetails:
        "0,25% of the order volume (min. 10,00 €, max. 75,00 €)",
    },
    dwsDepotTypeStep: {
      question:
        "Which of your DWS products would you like to benefit from Rentablo Cashback",
      fundDepot: "My funds depot",
      retirementPlan: "My DWS retirement plans (Riester / Rürup / Basisrente)",
    },
    payoutIbanStep: {
      question: "Where should we pay your cashback to?",
      placeholder: "IBAN",
    },
    payoutAccountHolderLastNameStep: {
      question: "Payout account: What is the account holders last name?",
      placeholder: "Last Name",
    },
    payoutAccountHolderFirstNameStep: {
      question: "Payout account: What is the account holders first name?",
      placeholder: "First Name",
    },
    promotionCodeStep: {
      question: "Do you have a promotion code?",
      placeholder: "Promotion code",
      validationSuccess: "Discount",
    },
    phoneNumberStep: {
      question: "Und which phone number may we reach out to you?",
      placeholder: "Phone number",
    },
    usTaxNumberStep: {
      question: "What is your US-TIN/-SSN?",
      questionPartner: "What is your partners US-TIN/-SSN?",
      questionMinor: "What is the minors US-TIN/-SSN?",
      questionLegalGuardian1: "What is the first legal guardians US-TIN/-SSN?",
      questionLegalGuardian2: "What is the second legal guardians US-TIN/-SSN?",
      placeholder: "US-TIN/-SSN",
    },
    dabMobileForTanStep: {
      question: "To which number should DAB send your TAN?",
      placeholder: "Mobile number for TAN",
    },
    fondsdepotSelectDepotTypeStep: {
      question: "Would you like to open a normal or a VL Depot?",
      normal: "Normal",
      vl: "VL-Depot",
    },
    accountIdentifierStep: {
      question: "What is the identifier of your existing depot",
      questions: {
        COBADEHDXXX: "What is your comdirect customer number",
        DABBDEMMXXX: "What is your DAB account base number",
      },
      placeholders: {
        AUGBDE77XXX: "10 digits (0-9)",
        COBADEHDXXX: "10 digits (0-9)",
        DABBDEMMXXX: "7 digits (0-9)",
        DEUTDEFFXXX: "8 symbols; starting with a letter and then 7 digits",
        COBADEMXXXX: "10 or 11 digits (0-9)",
        FFBKDEFFTHK: "10 digits (0-9)",
        FODBDE77XXX: "10 digits (0-9)",
        METZDEFFXXX: "10 digits (0-9)",
      },
      accountIdentifierIsUsedMessage:
        "This depot / customer identifier has already been used in another cashback subscription.",
    },
    comdirectCustomerHelpStep: {
      helpText: "Where can I find my customer number?",
      question: "Where can I find my comdirect customer number?",
      description:
        'You will find your customer number in section "Persönlicher Bereich" using menu item, "Verwaltung" -> "Meine Daten"',
    },
    startDateStep: {
      question: "When subscription can be started?",
      label: "Start Date",
    },
    selectAccountHolderStep: {
      question: "Would you like to add a depot to an existing account holder?",
      subheading:
        "Adding a depot to an account holder is for free. Our cashback fees apply only once per account holder, including joined depots.",
      onvistaSubheading:
        "Each account holder can manage any number of their own or joint custody accounts free of charge.",
      orAddNew: "or",
      newAccountHolder: "Add an account holder",
      newAccountHolderNote:
        "Rentablo-Cashback fees apply on a per-account holder basis. By klicking here, you create a new account holder which will be billed separately.",
      onvistaNewAccountHolderNote:
        "Billing and payment are made per account holder. If you click here, you will create a new account holder who will be billed and paid out separately. Use this function e.g. for partners or your children.",
    },
    // BREAKPOINT FOR GENERATORS DO NOT REMOVE
    helpStep: { close: "Close" },
    nextButton: {
      next: "Next",
      skip: "Skip",
    },
    orEnter: "or press ENTER",
    header: {
      phone: {
        title: "Questions?",
      },
    },
    userCreatedNotification:
      "User already created. You can not change this step anymore.",
  },
  banks: {
    COBADEHDXXX: "comdirect",
    DABBDEMMXXX: "DAB BNP Paribas",
    AUGBDE77XXX: "Augsburger Aktienbank",
    DEUTDEFFXXX: "DWS",
    DEUTLU2DXXX: "MorgenFund",
    COBADEMXXXX: "FNZ",
    FFBKDEFFTHK: "FIL Fondsbank (FFB)",
    FODBDE77XXX: "Fondsdepot Bank",
    METZDEFFXXX: "Metzler (MFX)",
  },
  countryAutocomplete: {
    mostUsed: "Most used",
    others: "Others",
  },
  bankFacts: {
    rating: {
      description: "Our Rating",
    },
    allBanksLink: "show me a comparison of all banks",
    comdirect: {
      depotFee: "0 € Depot-fee",
      numberOfFunds: "more then 23.000 funds",
      fundSavingsPlan: "0.95 € for fund savings plan",
      allInOne: "Trade Funds, Stocks and ETF",
    },
  },
  cashbackCalculator: {
    cashback: {
      50: "Cashback-50",
      100: "Cashback-100",
    },
    detailed: {
      cashbackAreaChart: {
        rentabloFee: "Max. {{fee}} for Rentablo per month",
        rentabloFeeXs: "Max. {{fee}} for Rentablo",
        rentabloFeeCB50: "For Rentablo",
        cashbackLabel: "Your funds-cashback",
        depotVolume: "Depot volume",
        portfolioCommission: "Portfolio Commission",
        fee: "For Rentablo",
        yourCashback: "Your Cashback",
        perMonth: "monthly",
      },
      inputSlider: {
        label: "Your wealth",
      },
    },
  },
  products: {
    free: {
      subheader: "Basis Funktionen mit Rentablo-Konto",
      features: [
        "1 Bankverbindung",
        "3 Jahre Hitorische Daten",
        "Support nur über das Nutzerforum",
      ],
    },
    plus: {
      subheader: "für Investoren im Vermögensaufbau",
      features: [
        "alle <strong>Basis-Funktionen inklusive</strong>",
        "<strong>5</strong> Bankverbindungen",
        "<strong>6 Jahre</strong> Historische Daten",
        "E-Mail Support innerhalb von 5 Tagen",
        "Umsatzlisten hochladen",
        "Crypto",
        "Dividenden",
      ],
    },
    pro: {
      subheader:
        "für Investoren, die ihr Vermögen selbst professionell verwalten",
      features: [
        "alle <strong>PLUS Funktionen inklusive</strong>",
        "<strong>unbegrenzt</strong> viele Bankverbindungen",
        "<strong>10 Jahre</strong> Historische Daten",
        "<strong>Telefon-Support</strong>,",
        "<strong>unbegrenzt</strong> Umsatzlisten hochladen",
        "Data Enrichment",
        "Reports and Export-optionen",
        "Simulatoren",
      ],
    },
  },
  fundamentals: {
    topHoldings: "Top 10 Holdings",
    chartMenu: { hide: "Hide" },
    metrics: {
      dividendsPerYear: {
        normal: "Historic dividends",
        short: "Dividends",
        desc: "The companies dividend payment history. All values are aggregated for full years.",
      },
    },
    dividends: {
      kpi: {
        latestDividend: "Last dividend ({{year}})",
        averageAndSum: "Ø yearly · Sum ({{count}} yrs)",
      },
    },
    detailInformation: {
      title: "Detailed information",
      marketCap: "Market capitalization",
      indexes: "Indexes",
      sector: "Sectors",
      lastUpdate: "Financials updated at",
      country: "Country",
    },
    year_one: "{{count}} Year",
    year_other: "{{count}} Years",
    ranksAndRisks: {
      fwwFundStars: "FWW FundStars®",
      fwwFundStarsInfo:
        "FWW FundStars® are based on risk-adjusted performance (RAP). This two-dimensional measure combines the return a fund achieved with the risk taken to achieve it (volatility). Funds are classified into 5 ranking tiers of 20 percent each, which determine the award of 5 down to 1 stars. The best 20 percent of funds receive five stars.",
      srri: "SRRI",
      srriInfo:
        "The Synthetic Risk and Reward Indicator (SRRI) measures the level of price fluctuation associated with investing in a fund. It is calculated using a methodology standardised across the EU and ranges from 1 to 7, where higher values indicate larger fluctuations. Larger fluctuations usually come with higher potential returns. An SRRI of 1 does not mean the investment is risk-free.",
      title: "Ratings and risks",
    },
  },

  investment: {
    isinMissing: {
      title: "Missing ISIN",
      subtitle:
        "There is currently no valid ISIN for this security. Please add the ISIN in the advanced settings.",
    },
    title: "Security",
    header: {
      chart: {
        subheader: "Current worth",
      },
      actions: {
        addBookingButton: "Add booking",
        create: "Create",
        uploadPdf: "Upload PDF",
        selectDepots: "Select Depots",
        moreButton: "More",
        editInvestmentButton: "Edit investment",
        deleteInvestmentButton: "Delete investment",
      },
      deleteModal: {
        question: "Delete this investment?",
        success: "Investment deleted successfully",
      },
    },
    details: {
      gainLossStatistics: {
        title: "My Performance",
        gainAndLoss: "G/L (Market returns + realized)",
        returnOnInvestment: "Market returns",
        realizedGains: "Realized gains",
        irr: "Yield (IRR) p. a. during {{years}} years",
        twror: "Performance",
        purchasePrice: "Purchase price",
        investedAmount: "Invested amount",
        marketValue: "Market value",
        tradingGains: "Trading gains",
        dividends: "Dividends",
        commission: "Commission",
        tax: "Taxes",
        fromMarketReturns: "from market returns",
        fromMarketAndCurrencyReturns: "from market and exchange rate returns",
        fromDividendsAndKupons: "from dividends/kupons",
      },
    },
    performance: "Performance",
    tabs: {
      fundamentals: "Fundamentals",
      protocol: "Protocol",
      dividends: "Dividends",
    },
    protocolTable: {
      bookingType: "Type",
      overallValue: "Total value",
      period: "Period",
      amount: "Amount",
      expenses: "Expenses",
      totalSum: "Sum",
      noBookings: "No bookings for the time range",
      comment: "Comment",
      cancelled: "Cancelled",
      gainersAndLosersLabel: "GuV",
      actions: {
        title: "Actions",
        addBooking: "Add booking",
        edit: "Edit",
        delete: "Delete",
      },
      deleteDialog: {
        title: "Deleting a booking",
        questionMessage: "Are you sure you want to delete this booking?",
        actions: {
          close: "Close",
          delete: "Delete",
        },
      },
    },
    dividends: {
      noDividends: "No dividends. Would you like to add manually?",
      noDividendsAddLink: "Add",
      addDividends: "Add custom",
      splitAdjust: "Split adjusted",
      missingDividends: {
        header_one: "There is {{value}} missing dividend.",
        header_other: "There are {{value}} missing dividends.",
        addBatchButton: "Add now",
      },
      dividendsTableHeaders: {
        date: "Date",
        dividend: "Dividend",
        lots: "Lots",
        total: "Total",
        actions: "Actions",
      },
      tableActions: {
        addDividends: "Add",
        editDividends: "Edit",
      },
    },
    recommendation: {
      title: "Product suggestions",
      description:
        "We have found products that better match your portfolio and preferences. The product can be added to the chart using the checkbox.",
      showAll: "View all suggestions",
    },
  },
  singleAccountPage: {
    breadcrumbs: {
      home: "Home",
      accounts: "Accounts",
    },
    header: {
      account: "Account",
      update: "Update",
      addTransaction: "Add transaction",
      edit: "Edit",
      manageBankConnection: "Manage Bank Connection",
      hide: "Hide",
      show: "Show",
      delete: "Delete account",
      deleteModal: {
        question: "Delete this account?",
      },
    },
    protocolTable: {
      title: "Transactions",
      headers: {
        valueDate: "Value Date",
        bookingDate: "Booking Date",
        bookingInformation: "Booking information",
        value: "Amount",
      },
      search: {
        placeholder: "Search",
      },
      noPurpose: "Not available",
      export: "Export CSV",
      noItems: "No transactions for the time range",
      transfer: "Transfer",
      adjustingEntry: "Adjustment entry",
      adjustingEntryText:
        "If the account balance falls below zero due to a purchase, it will be automatically adjusted.",
      interval: {
        everyMonth: "Every Month",
        biMonthly: "Bi-Monthly",
        quarterly: "Quarterly",
        biAnnual: "Bi-Annual",
        annual: "Annual",
      },
    },
  },
  addManuallyPage: {
    addManuallyBreadcrumb: "Add transaction manually",
    header: {
      title: "Cash transaction",
      subtitle: "Create a new cash transaction",
    },
    form: {
      additionalInformation: {
        summary: "Additional information",
        interestTitle: "Interest / Fees:",
        interestBody:
          "Interest or fees such as custody account fees. Debit interest and fees have a negative sign, credit interest a positive sign.",
        otherGainsTitle: "Other profits:",
        otherGainsBody:
          "Profits from (unrecognized) securities transactions. This could be a refund or some other profit, for example.",
        taxRefundTitle: "Taxes / Refunds:",
        taxRefundBody:
          "Taxes paid or tax refunds received. Taxes paid have a negative sign, refunds received have a positive sign.",
      },
      type: "Type of transaction:",
      types: {
        withdrawal: "Withdrawal",
        deposit: "Deposit",
        interest: "Interest / Fees",
        tax_refund: "Taxes / Refunds",
        other_gains: "Other profits",
      },
      netAmount: "Net amount:",
      taxAmount: "Taxes:",
      totalAmount: "Total amount:",
      date: "Paid on:",
      datepickerCancelButton: "Cancel",
      purpose: "Comment:",
      hints: {
        other_gains:
          "Other gains can have a strong impact on performance. Please only mark this transaction as Other Profits if it was actually a trading profit, a tax refund or similar.",
      },
      submit: "Save",
      messages: {
        success: "Saved successfully",
      },
    },
  },
  createAndEditAccount: {
    editBreadcumb: "Edit",
    header: {
      title: "Edit: {{value}}",
    },
    actions: {
      save: "Save",
      delete: "Delete",
      deleteAllInvestments: "You also can delete all investments",
      deleteAllCashTransactions: "You also can delete all cash transactions",
    },
    deleteDialog: {
      titleInvestments: "Deleting all investments",
      titleAllCashTransactions: "Deleting all cash transactions",
      questionInvestments: "Are you sure you want to delete all investments?",
      questionCashTransaction:
        "Are you sure you want to delete all cash transactions?",
      close: "Decline",
      delete: "Delete",
    },
  },
  watchlistEntry: {
    details: {
      gainLossStatistics: {
        title: "Market returns",
        gainAndLoss: "Market returns",
        entryQuote: "Entry quote",
        currentQuote: "Current quote",
        historicReturns: "Historic performance",
      },
    },
  },
  depotTransfer: {
    title: "Depot transfer",
    header: { backButton: "Back", title: "Depot transfer" },
    selectTransferTypeStep: {
      question: "Do you want to transfer your depot in full or partially?",
      full: "In full",
      partial: "Partially",
    },
    depotAutocompleteStep: {
      question: "To which depot do you want to transfer to?",
      placeholder: "Select depot",
    },
    dateOfTransferStep: {
      question: "When did the transfer happen?",
      label: "Date of transfer",
    },
    investmentsTable: {
      investments: "Investments",
      totalNumberOfLots: "Total",
      transferNumberOfLots: "Transferred Amount",
    },
    validation: {
      destinationAccountIdIsEmpty: "Destination depot must be selected",
      investmentsToTransferIsEmpty: "Please select investments to transfer",
      investmentsToTransferIsIncorrect:
        "The number of lots is incorrect for some investments",
      numberOfLotsCanNotBeLessThanZero: "can not be less than zero",
      numberOfLotsCanNotBeMoreThanOriginal:
        "can not be more than original value",
      dateOfTransferCanNotBeInFuture: "Date of transfer can not be in future",
      dateOfTransferCanNotBeEmpty: "Date of transfer must not be empty",
    },
    successStep: {
      message: "Investments were successfully transferred",
      finishButton: "Back to depot",
    },
    fullLotsStep: {
      question: "Did your bank transfer everything or only full lots?",
      onlyFullLots: "Only full lots",
      fullLotsAndPartials: "Everything",
    },
    selectInvestmentsStep: {
      question: "Which investments do you want to transfer?",
      noInvestments: "You have no investments",
    },
  },
  bankConnections: {
    success: {
      message: "Import completed",
      toDepots: "To the depot overview",
    },
    legalNote: {
      title: "Import Depots/Accounts",
      poweredBy: "Powered by wealthAPI",
      finApi:
        "wealthAPI guarantees you secure access to your bank data. For this purpose, we work with finAPI, an established provider that banks such as DKB or ING also trust.",
      dataProtection:
        "wealthAPI treats your data absolutely confidentially. It will not be passed on to third parties.",
      next: "Accept and continue",
    },
  },
  selectContraAccount: {
    accountTypeFromBank: {
      CHECKING: "Checking Account",
      SAVINGS: "Savings Account",
      CREDIT_CARD: "Credit Card",
      DEPOT: "Depot",
      LOAN: "Loan",
      MEMBERSHIP: "Membership",
      HOME_PURCHASE_SAVINGS: "Home Purchase Savings",
      REFERENCE_ACCOUNT: "Reference Account",
      FOREIGN_CURRENCY_ACCOUNT: "Foreign Currency Account",
    },
    title: " Select clearing account",
    nextButton: "Continue",
    depotIndex: "{{index}} of {{total}}",
    noAccount: "Without clearing account",
    noAccountWarning:
      "Without clearing account only limited functionality! No transfer of dividends and exact data from transactions",
    showAllAccounts: "Show all bank accounts",
    showAccountsForSameBank: "Show only bank accounts",
  },
  assignContraAccount: { title: "Assign clearing account" },
  synchronizationLog: {
    title: "Last Updates",
    noUpdateRequired: "Positions are current",
    new: "NEW",
    rollback: "Discard changes",
    rolledBack: "DROPPED",
    checkRequired: "CHECK",
  },
  depotsSelector: {
    allDepots: "All Depots",
    amountDepots: "{{ selected }} of {{ total }} Depots",
    noDepots: "No Depots",
    allAccounts: "All Accounts",
    amountAccounts: "{{ selected }} von {{ total }} Konten",
    noAccounts: "No Accounts",
  },
  regionSelector: {
    label: "Select a region",
  },
  industrySelector: {
    label: "Select an industry",
  },
  tagSelector: {
    label: "Select or create a tag",
    addNewOption: 'Create "{{name}}" tag',
  },
  classifications: {
    title: "Analyze",
    breadcrumbs: {
      home: "Home",
      classifications: "Depot-Classification",
    },
    tabs: {
      investments: "Investments",
      investmentType: "Asset class",
      region: "Region",
      industry: "Industry",
      risk: "Volatility",
      currency: "Currency",
      yield: "Yield",
      tag: "Custom groups",
    },
    empty: {
      title: "No data for this view",
    },
    assignTagToInvestment: "Assign tag to Investment",
    assignRegionToInvestment: "Assign region to Investment",
    assignIndustryToInvestment: "Assign industry to Investment",
    risk: {
      title: "Investments by risk",
      tooltip:
        'High: The risk of securities is classified as "high" if the volatility is above 25 percent. <br><br>Moderate: The risk of securities is classified as "moderate" if the volatility is between 15 and 25 percent.<br><br>Low: The risk of securities is classified as "low" if the volatility is below 15 percent.',
      unclassified: "Not classified",
      numberToWord: {
        0: "Low",
        1: "Moderate",
        2: "High",
      },
    },
    yield: {
      title: "Investments by yield",
      tooltip:
        'High: The yield on securities is classified as "high" if the return per year is over 12 percent. <br><br>Moderate: The return on securities is classified as "moderate" if the return per year is between 6 and 12 percent.<br><br>Low: The return on securities is classified as "low" if the return per year is less than 6 percent',
      unclassified: "Not classified",
      numberToWord: {
        0: "Low",
        1: "Moderate",
        2: "High",
      },
    },
    tag: {
      assignTitle: "Assign a tag",
      title: "Your groups",
      unclassified: "Unclassified",
    },
    investmentType: {
      title: "Investments by type",
      types: {
        "11_stock": "Stocks",
        "21_fund": "Funds",
        "31_bond": "Bonds",
        "41_cash": "Cash",
        "51_certos": "Certificates / OS",
        "61_pmetals": "Precious Metals",
        "71_massets": "Material Assets",
        "81_fcurr": "Foreign Currencies / Crypto",
        "22_etf": "ETF",
        "91_managed": "Robo / Crowd",
      },
    },
    currency: {
      title: "Investments by currency",
    },
    region: {
      assignTitle: "Assign region",
      title: "Investments by region",
    },
    industry: {
      assignTitle: "Assign industry",
      title: "Investments by industry",
    },
  },
  investmentTypeClassification: {
    types: {
      "11_stock": "Stocks",
      "21_fund": "Funds",
      "31_bond": "Bonds",
      "41_cash": "Cash",
      "51_certos": "Certificates / OS",
      "61_pmetals": "Precious Metals",
      "71_massets": "Material Assets",
      "81_fcurr": "Foreign Currencies / Crypto",
      "22_etf": "ETF",
      "91_managed": "Robo / Crowd",
    },
  },
  newsPage: {
    title: "News",
    noNews: "No news available",
    loadError: "News could not be loaded.",
  },
  communityPage: {
    title: "Community",
    noThreads: "No discussions available",
    loadError: "Discussions could not be loaded.",
    threadMeta: {
      lastPost: "Last post by {{author}}",
      replies_one: "{{count}} reply",
      replies_other: "{{count}} replies",
    },
  },
  dividendPlannerPage: {
    title: "Revenues",
    addButton: "Add",
    statistics: {
      portfolioValue: "Portfolio Value",
      received: "Received Dividends",
      yield: "Dividend Yield",
      predicted: "Prediction {{year}}",
      predictedYield: "Div. Yield {{year}}",
      cagr: "CAGR",
      currentYear: "Current Year",
      year: "Year {{year}}",
      years_one: "{{count}} year",
      years_other: "{{count}} years",
    },
    chart: {
      title: "Dividends Current Year",
      dividendYield: "Dividend Yield",
      lastYear: "last year",
      total: "Total",
      tooltipReceived: "rec. Div",
      tooltipPredicted: "pred. Div",
    },
    myDividends: "My Dividends",
    exportPdfBtn: "Export as PDF",
    predictDropdown: {
      predictYears: "Predict Years",
      hideForecast: "Hide Forecast",
      lists: {
        nextYear: "Simulate next year",
        twoYears: "Simulate 2 years",
        fiveYears: "Simulate 5 years",
        tenYears: "Simulate 10 years",
      },
    },
    tabs: {
      overview: "Overview",
      calendar: "Dividend Calendar",
    },
    chips: {
      table: "InvestmentsTable View",
      calendar: "Calendar view",
    },
    forecast: "Forecast",
    showAll: "Show all",
    showLess: "Show less",
    showMore: "show more",
    calendar: {
      noData: "No dividends",
    },
    dividendContains_one: "Contains {{count}} dividend",
    dividendContains_other: "Contains {{count}} dividends",
    searchPlaceholder: "Name / Month",
    quote: "Course",
    table: {
      name: "Name",
      dueIn: "Due in",
      dividendAmount: "Dividend /\nAmount",
      yieldPrice: "Personal yield /\npurchase price",
      currentYP: "Current Yield /\nCurrent Price",
      dividend: "Dividend",
      amount: "Amount",
      personalYield: "Personal Yield",
      purchasePrice: "Purchase Price",
      currentYield: "Current Yield",
      currentPrice: "Current Price",
      sharesShort: "St.",
      groupByMonth: "Group by month",
      expected: "Probably",
      notRecorded: "Dividend not recorded",
      noFound: "No data is found",
      dividendPerShare: "Dividend per share",
      shares: "Shares",
      tax: "Tax & fees",
      paymentDate: "Payment date",
      banners: {
        title: "No tax data entered",
        text: "We can calculate your net amounts and display them here if you provide your tax information",
        supplementBtn: "Supplement tax data",
        notNowBtn: "Not now",
      },
      expand: {
        dividends: "Dividends",
        amount: "Amount",
        currentYield: "Current Yield",
        personalReturns: "Personal Return",
        gross: "(Gross)",
        net: "(Net)",
        grossTooltip: "Gross amount (before taxes)",
        netTooltip: "Net amount (after taxes)",
      },
    },
  },
  csvImport: {
    title: "Import CSV",
    formatSelector: { label: "Select CSV format" },
    csvUpload: {
      text: "Drag or select CSV here",
      error:
        "Error uploading. Please check whether the uploaded File corresponds to the format, or try a different file.",
      genericHint:
        "Please import the CSV file with your transaction data here. You can download a generic CSV template <linkText>here</linkText>. In addition, the following formats are supported:",
      currencyWarning:
        "Important: The CSV import does not support the conversion of foreign currencies. Please ensure that all entries and transactions are specified in euros.",
      incompatible: {
        "01_depot":
          "The import of cash transactions into a depot is not possible. Please select an account to import the cash transactions from the CSV file.",
        "02_cash":
          "The import of security bookings into an account is not possible. Please select a depot to import the security bookings from the CSV file.",
      },
    },
    banksTable: {
      depot: "Depot bookings",
      account: "Account transactions",
      emptyText: "No booking or transaction banks found.",
    },
    edit: "Edit",
    delete: "Delete",
    parsingResults: {
      date: "Date",
      name: "Name",
      number_of_lots: "Number",
      number_of_lots_bond: "Amount",
      security_price: "Deposit Price",
      commission: "Fees",
      isin: "ISIN",
      tax_amount: "Taxes",
      transaction_type: "Transaction type",
      asset_type: "Investment type",
      currency: "Currency",
      exchange_rate: "Exchange rate",
      tax_and_commission_in_eur: "Taxes and fees in EUR",
      error: "Entry for {{name}} is missing",
      saveSuccess: "Transactions were imported successfully",
      savePending: "Import is being processed, please wait...",
      saveError: "An error occurred while saving transactions",
      correctionHint:
        "Please correct all erroneous transactions before importing them.",
      allCorrected:
        "All erroneous transactions have been successfully corrected.",
    },
    cashParsingResults: {
      bank_booking_date: "Date",
      counterpart_name: "Name",
      counterpart_iban: "IBAN",
      purpose: "Booking information",
      amount: "Amount",
      error: "Entry for {{name}} is missing",
    },
  },
  transactionUpload: {
    title: "Import transactions",
    transactionTypes: {
      buy: "Buy",
      sell: "Sell",
      dividend: "Dividend",
      book_in: "Book-In",
      book_out: "Book-Out",
    },
    dropOrSelectFile: "Drop PDFs here or select files",
    dropOrSelectFileHint: "No more than 10 files up to 2MB each",
    newInvestment: "New",
    newTransaction: "New",
    updateTransaction: "Update",
    tax: "Tax",
    fee: "Commission",
    persistData: "Import data",
    depot: "Depot",
    ignoreErrors: "Ignore errors",
    success: {
      importSuccess: "Successfully imported",
      importDetails: "Imported positions",
      toDepot: "Back to depot",
      toInvestments: "Back to investments",
    },
    somethingWrong:
      "An error occurred and we were unable to parse the file properly. Please check your file details.",
    placeholder: "Select depot",
  },
  authContext: {
    loginTitle: "Login",
    emailConfirmationTitle: "Please confirm your email",
  },
  emailConfirmation: {
    line1:
      "We have sent you an email to confirm your account. Please complete the registration by clicking on the confirmation link contained in the email.",
    line2:
      "If you have not received an email, please also check your spam folder if necessary.",
    success: "We have sent you an email to confirm your account.",
    button: "Resend email",
    confirmationExpiredError:
      "Registration could not be confirmed. Most likely your confirmation link has already expired.",
    logout: "Cancel registration",
  },
  netfondsConsent: {
    title: "Cashback: One-Click Import",
    heading: "New: One-Click Data import",
    teaser:
      "We proudly announce our seamless depot import - exclusively for Rentablo Cashback customers.",
    description:
      "Import your Cashback-Depots with a single click into the Rentablo finance manager and improve your investment returns.",
    activateDataImport: "Activate data import",
    doNotActivateDataImport: "Do not activate data import",
    deactivated: "One-click import is deactivated",
    howToActivate:
      "You may activate the one-click import in your <1>Cashback-Dashboard</1> at any time.",
    done: "Back to dashboard",
    changedYourMind: "Changed your mind?",
    selectAccountHolders: "Select account holder",
    selectAccountHoldersDescription:
      "One-Click import will be enabled for the selected account holders.",
    importingData: "Importing depots...",
    importingDataDescription:
      "We are now importing your investment and transaction data. If you have a lot of (historic) transaction data, this may take up to several minutes.",
    somethingWrong: {
      title: "Import failed",
      contactSupport:
        "Please contact our support using {{supportEmail}} if this problem persist.",
    },
    deleteAccounts: {
      heading: "Delete already imported depots?",
      teaser:
        "Depots and accounts were already imported via the Cashback interface. Would you like to delete them now?",
      delete: "Delete depots",
      keep: "Keep data",
    },
    breadcrumbs: {
      title: "One-Click Import",
    },
  },
  addDividendWizard: {
    title: "Dividends",
    addManualDividendStep: {
      title: "Enter the dividend information",
      date: "Date",
      securityPrice: "Price",
      exchangeRate: "Exchange rate",
      taxAmount: "Tax amount",
      commission: "Commission",
      taxAndCommissionInEur: "Tax and commission in EUR?",
      amount: "Amount",
      amountAC: "Amount (EUR)",
      errors: {
        title: "Validation errors",
      },
    },
    confirmManualDividendStep: {
      title: "Summary of your dividend information",
      amount: "Amount:",
      date: "Date:",
      tax: "Tax:",
      commission: "Commission:",
      exchangeRate: "Exchange rate:",
      total: "Total:",
      totalAC: "Total (€):",
      saveButtonLabel: "Save",
    },
    breadcrumbs: {
      create: "Create a dividend",
    },
  },
  batchDividendsWizard: {
    title: "Dividends",
    listDividendsStep: {
      title: "Select the outstanding dividends",
      subtitle:
        "The selected dividends are automatically imported into your portfolio",
      splitAdjust: "Split adjusted",
    },
    dividendsTable: {
      headers: {
        date: "Date",
        amount: "Amount",
        lots: "Lots",
      },
    },
    taxRequestStep: {
      taxQuestion: "Would you like to apply a tax rate?",
      acceptTax: "Yes",
      declineTax: "No",
    },
    taxInputStep: {
      title: "Enter your tax rate",
      customTaxLabel: "Tax rate",
    },
    summaryStep: {
      title: "Summary of your dividend and tax data",
      saveButtonLabel: "Save",
      dividendsTable: {
        headers: {
          date: "Date",
          amount: "Received",
          tax: "Tax",
          total: "Total",
        },
      },
    },
  },
  editDividendWizard: {
    title: "Edit dividend",
  },
  transactionWizard: {
    new: {
      title: "Add investment",
    },
    manual: {
      title: "Add investment manually",
    },
    add: {
      title: "Add transaction",
    },
    edit: {
      title: "Edit transaction",
    },
    searchSymbolsStep: {
      title: "Find securities",
      noQuoteModal: {
        title: "No Automatic Quote Feed",
        text: "Unfortunately, we cannot provide an automatic quote feed for the selected security. Please create the investment entry manually and update the quotes yourself when needed.",
        confirm: "Create Manual Investment",
      },
    },
    selectCurrencyStep: {
      title: "Select investment currency",
      currency: "Currency",
      tryPlusMessage: "Foreign currencies are a PLUS Feature.",
    },
    investmentTypeStep: {
      title: "Type of the investment",
    },
    bookingTypeStep: {
      title: "What would you like to enter?",
      mostUsed: "Most used",
      specials: "Special transaction types",
      buy: "Buy",
      sell: "Sell",
      book_in: "Book-in",
      book_out: "Book-out",
      switch: "Switch / fusion",
      retained_dividend: "Retained dividend / free shares",
      carve_out: "Carve-out",
      split: "Split",
      disabledInformation:
        "This transaction type is only available for existing investments. Select this type from your investment options.",
    },
    priceAndDateStep: {
      title: "Order data",
      date: "Date",
      numberOfLots: "Lots",
      numberOfLotsPercent: "Value",
      numberOfLotsGram: "g",
      numberOfLotsOunces: "Ounces",
      securityPrice: "(Historic) entry price",
      bookOutPrice: "Booked out for",
      entryQuote: "Price",
      currency: "Currency",
      exchangeRate: "Exchange Rate",
      commission: "Commission",
      taxAmount: "Taxes",
      taxAndCommissionInEur: "Tax and commission in EUR?",
      totalAmount: "Total",
      totalAmountAC: "Total (EUR)",
      depotValuationAfterBooking: "Depot valuation after this booking",
      gram: "Gram",
      ounces: "oz",
      lots: "Pc.",
      comment: "My notes",
    },
    ratioAndDateStep: {
      title: "Split",
      date: "Date",
      ratio: "Ratio",
      isReverse: "Reverse split?",
    },
    nameAndDepotStep: {
      title: "Select name and depot",
      name: "Name",
      selectDepot: "Select depot",
      newDepot: "New Depot",
      comment: "My notes:",
      investmentExists: "You already have {{lots}} lots in this depot",
    },
    newDepotStep: {
      title: "Create a new depot",
      name: "Depot name",
    },
    inputFieldWithRevert: {
      revert: "Reset",
      revertDescription: "Reset to original value of {{value}}",
    },
    summaryStep: {
      title: "Order summary",
      date: "Date",
      securityPrice: "(Historic) entry price",
      entryQuote: "Price",
      exchangeRate: "Exchange Rate",
      expenses: "Expenses",
      currency: "Currency",
      totalAmount: "Total",
      totalAmountAC: "Total (€)",
      persist: "Save data",
    },
    splitPreviewStep: {
      title: "Split applied to:",
      titleReverse: "Reverse split applied to:",
      persist: "Save data",
    },
    persistedStep: {
      title: "Data saved",
      showInvestments: "Go to investments",
    },
    somethingWrong: {
      title: "Internal error",
      contactSupport:
        "Please contact our support using {{supportEmail}} if this problem persist.",
      done: "Back to Investments",
    },
  },
  symbolSearch: {
    title: "Search securities",
    searchLabel: "Name, ISIN, WKN",
    noData: "Sorry, no results",
    examples: "Examples",
    example1: "Daimler or DE0007100000",
    example2: "Bitcoin or BTC",
    example3: "Gold or Silver",
    example4: "Dollar or USD",
    manualInvestmentLabel: "Security not available?",
    manualInvestment: "Create manual investment",
  },
  sidebar: {
    header: { title: "Finanzmanager", testPremium: "Test premium" },
    footer: {
      imprint: "Imprint",
      privacy: "Privacy",
      terms: "Terms",
      disclaimer: "Disclaimer",
      wealthApi: "wealthAPI GmbH",
      phoneInfo: "Available Monday to Friday from 9 a.m. to 7 p.m.",
    },
  },
  appSidebar: {
    searchField: "Search",
    menu: {
      accounts: "Konten",
      admin: "Administration",
      capitalMeasure: "Capital Measure",
      cashbackBookings: "Cashback Bookings",
      securitiesAdmin: "Securities Admin.",
      bankAdmin: "Bank Admin. & Reports",
      other: "Other Admin.",
      isinChanges: "ISIN Changes",
      securityType: "Security Type Changes",
      assetReport: "Asset Report",
      apiRefresh: "Historic Quotes Refresh",
      cryptoRefresh: "Crypto Currencies",
      mergers: "Mergers",
      spinOffs: "Spin-Offs",
      purchaseRight: "Purchase Rights",
      backToLegacy: "Zurück zu v1",
      bankEvents: "Connection Events",
      bankLogs: "Bank Logs",
      bankMessages: "Banknachrichten",
      bankHealth: "Bank Health Reports",
      cashback: "Cashback",
      analyse: "Analyse",
      names: "Preferred names",
      cashflowAnalyzer: "Cashflow-Analyzer",
      contractAnalyzer: "Contract-Analyzer",
      contractAnalyzerV2: "Contract-Analyzer V2",
      providerName: "Provider name",
      etfs: "ETFETC Classifications",
      logos: "Company Logo",
      classification: "Klassifizierung",
      community: "Community",
      contracts: "Contracts",
      depots: "Depots",
      depotsAndAccounts: "Depots & Konten",
      dividendPlanner: "Erträge",
      dividends: "Dividenden Verwaltung",
      home: "Home",
      interfaces: "Schnittstellen Verwaltung",
      investments: "Investments",
      logout: "Logout",
      newCashback: "Neue Buchung",
      news: "News",
      oneClickImport: "One-Click Import",
      overview: "Übersicht",
      performance: "Depotanalyse",
      portfolio: "Portfolio",
      profile: "Profil",
      risk: "Return and risk",
      settings: "Einstellungen",
      splits: "Split Verwaltung",
      watchlists: "Watchlists",
      depotCheck: { main: "Depotoptimierung", questionnaire: "Fragebogen" },
    },
  },
  quickBar: {
    home: "Home",
    investments: "Investments",
    analyse: "Analyse",
    depots: "Depots",
  },
  premium: {
    tryPlusMessage:
      "Do better investment decisions and try Rentablo <1>PLUS</1> for free today!",
    tryProMessage:
      "Do better investment decisions and try Rentablo <1>PRO</1> for free today!",
    tryPlus: "Try Rentablo PLUS",
    tryPro: "Try Rentablo PRO",
    bnBlurOverlay: {
      title: "Unlock all premium features",
      subtitle:
        "Connect your Smartbroker+ depot and use dividend analysis, portfolio evaluation and more — free forever.",
      connectDepotLabel: "Connect depot",
      openDepotLabel: "Open depot",
    },
    smartbrokerPlusExpired: {
      title: "Premium features no longer active",
      close: "Dismiss notice",
      outdated: {
        text: "No longer unlocked for premium?\nUpdate your Smartbroker+ depot and use the premium features in PortfolioPlus again.",
        cta: "Update depot",
      },
      deleted: {
        text: "No longer unlocked for premium?\nImport your Smartbroker+ depot again and use the premium features in PortfolioPlus again.",
        cta: "Import depot",
      },
    },
    featuresModal: {
      brand: "{{appName}} premium",
      title: "Unlock exclusive content",
      subtitle: "Your free access to professional investor tools",
      features: {
        dividends: "Dividend calendar",
        returns: "Performance view",
        classifications: "Custom classifications",
      },
      freeBox: {
        title: "Completely free. No follow-up costs.",
        text: "Access to all premium features is permanently free — linked to a free Smartbroker+ depot that you can cancel again at any time.",
      },
      howToProceed: "How would you like to proceed?",
      connectDepot: {
        title: "Link Smartbroker+ depot",
        subtitle: "I already have a depot",
      },
      openDepot: {
        title: "Open a free depot now",
        subtitle: "I don't have a Smartbroker+ depot yet",
      },
    },
  },
  onlyForProBlock: {
    title: "Only for Premium members",
    updateToPro: "Unlock Premium now",
  },
  portfolioLimit: {
    tooltipText:
      "In the free account, the import is limited to a maximum of 2 portfolios. Importing additional portfolios is only possible for Premium members.",
  },
  intervalSelector: {
    compact: {
      oneWeek: "1W",
      oneMonth: "1M",
      sixMonths: "6M",
      oneYear: "1Y",
      sinceBeginning: "Since the beginning",
    },
    oneWeek: "1 week",
    oneMonth: "1 month",
    oneYear: "1 year",
    sinceBeginning: "Since the beginning",
  },
  dateRangePickerDialog: { submitButton: "Set", cancelButton: "Cancel" },
  aggregatedChart: {
    legend: {
      overview: "Overview",
      securities: "Securities",
      accountsAndCards: "Accounts & Cards",
    },
  },
  customTooltip: {
    securitiesLabel: "Securities",
    cardsAndAccountsLabel: "Accounts & Cards",
  },
  userDetails: {
    lastLogin: "Last login:",
    hello: "Hello",
  },
  sideBarMenu: {
    title: "Whitebox Analyze",
    allAssets: "All assets",
    securities: "Securities",
    cardsAndAccounts: "Accounts & Cards",
    settings: "Settings",
    help: "Help & Support",
    logout: "Log out",
    myWhiteboxSecurities: "My Whitebox securities",
    mySecurities: "My securities",
  },
  securitiesChart: {
    legend: {
      overview: "Overview",
      holdings: "Securities",
      etfs: "ETF",
      bonds: "Bonds",
      funds: "Funds",
      derivative: "Derivative",
    },
    typeSwitcher: {
      performance: "Performance",
      valuation: "Valuation",
      disabledTooltip: "Comparison is only supported in mode ‘performance’",
    },
  },
  promotionTeaser: {
    title: "Improve your chances of return!",
    desc: "This depot could do a lot better as a whitebox system and generate up to 5% more return/year.",
    disclaimer:
      "This is a disclaimer and/or risk information, if we need to show one here, when we advertise a higher roi with a Whitebox Investment.",
    buttonMore: "More info",
    buttonNo: "No, thanks",
    percent: "+5%",
    percentSubtitle: "up to 5% more a year",
  },
  investmentsPage: {
    overview: "Overview",
    isinInvalid: "The ISIN is invalid",
    header: {
      title: "Investments",
      actions: {
        newDepot: "New Depot",
        newPortfolio: "New Portfolio",
        newTransaction: "New Transaction",
        main: "Create new",
        create: "Create",
        uploadPdf: "Upload PDF",
        uploadCsv: "Upload CSV",
      },
    },
  },
  portfolioShare: {
    share: "Share",
    privatePortfolio: {
      noAccess: "You do not have access to this portfolio.",
      close: "Create account",
    },
    banner: {
      portfolio: 'You are currently viewing the dashboard "{{portfolio}}".',
      createYourOwn: "Create your own dashboard now",
      toMyDashboard: "To my dashboard",
      register: "Log in",
    },
    modal: {
      title: "Set view",
      secondTitle: "Share dashboard",
      table: { selectAll: "Select all", name: "Name", bank: "Bank" },
      selectButton: "Show portfolio",
      shareButton: "Share dashboard",
      acceptButton: "Take over",
      goToPortfolio: "To dashboard",
      publishButton: "Publish dashboard",
      closeButton: "Close",
      cashPositionsShared:
        "The cash position of your clearing accounts will also be shared if your dashboard is public.",
      private: "Private",
      privateTooltip:
        "With this selection, your portfolios remain visible only to you. If you have already shared your portfolios publicly, you can block visibility again here. The public view is then deactivated again.",
      public: "Public",
      publicTooltip:
        "This selection allows you to share your portfolio with others. You can display absolute or percentage values. If you display percentage values, others will not know how much capital you have invested.",
      onlyPercentage: "Show only percentage values",
      dashboardName: "Public dashboard name",
      dashboardName_placeholder: "e.g. 7030 Portfolio",
      linkWasCopied: "The link to your dashboard has been copied.",
      linkToDashboard: "Link to the dashboard",
      copyLink: "Copy link ",
    },
  },
  investmentEditPage: {
    header: "Edit",
    breadcrumbs: {
      edit: "Edit",
    },
    noInvestment: "Failed to load investment",
    tabs: {
      basic: "Basic",
      quoteData: "Quote data",
      advanced: "Advanced",
    },
    basicTab: {
      name: "Name",
      depot: "Depot",
      industry: "Industry / Sector",
      region: "Region / Country",
      customGroup: "Custom group",
      saveButton: "Save",
      saved: "Data saved",
    },
    quoteDataTab: {
      selectedText: "Selected: ",
      nothingSelectedText: "Nothing selected",
      saveButton: "Save",
    },
    advancedTab: {
      investmentType: "Investment type:",
      investmentCurrency: "Investment currency:",
      isin: "ISIN",
      wkn: "WKN",
      comment: "My notes",
      commentSaveError: "Could not save notes",
      saveButton: "Save",
    },
  },
  dashboardPage: {
    allAssets: "Your assets",
    modeBanner: {
      text: "New: The Rentablo finance manager is now also available in dark mode. <linkText>Try Dark Mode now<linkText>",
    },
    allYourAssets: "Your asset allocation",
    investmentsLink: "Go to Investments",
    depot: {
      title_one: "{{count}} Depot",
      title_other: "{{count}} Depots",
      noAccountsTitle: "No depots",
      noAccountsSubtitle:
        "You do not have any depots, do you want to add them now?",
      noAccountsButtonText: "Add now",
    },
    currentAssetsBlock: {
      chart: "Chart",
      gainersLosers: "Gainers & Losers",
      gainersLosersShort: "G&L",
      statistic: {
        returnOnInvestment: "Price gain",
        cash: "Cash",
        dividends: "Dividents",
        realizedGain: "Realized gain",
      },
    },
    investments: {
      title_one: "{{count}} Investment",
      title_other: "{{count}} Investments",
      noAccountsTitle: "No investments",
      noAccountsSubtitle:
        "You do not have any investments, do you want to add them now?",
      noAccountsButtonText: "Add now",
    },
    account: {
      title: "{{count}} Account",
      title_other: "{{count}} Accounts",
      noAccountsTitle: "No accounts",
      noAccountsSubtitle:
        "You do not have any accounts, do you want to add them now?",
      noAccountsButtonText: "Add now",
    },
    whitebox: {
      title_one: "{{count}} Whitebox-Anlage",
      title_other: "{{count}} Whitebox-Anlagen",
      noAccountsTitle: "No whitebox accounts",
      noAccountsSubtitle:
        "You do not have any whitebox accounts, do you want to add them now?",
      noAccountsButtonText: "Add now",
    },
    cashbackCard: {
      withSubscriptions: {
        title: "Cashback booking",
        text: "For your booking we need a few things:",
        text_processed: "Your booking is being processed:",
        text_active: "You can now import your cashback depots",
      },
      noSubscriptions: {
        title: "Get bonus",
        subtitle: "Recruit a friend",
        text: "Bring a friend to Rentablo and get €15 as a reward.",
      },
      statusMessage: {
        processed: "Active",
        incomplete: "Draft; please complete wizard",
        in_progress: "Please submit documents",
        internal_processing: "Documents received - In progress",
        processing_at_bank: "Forwarded to bank",
        processing_at_bank_reduced: "Opening process forwarded to bank",
      },
    },
    netfondsImportCard: {
      consentRequired: {
        title: "Your consent is required",
        body: "We need your consent to import your Netfonds data",
      },
      importAvailable: {
        title: "One-Click Import available",
        body: "Activate seamless import of your cashback depots now",
      },
      detailsButton: "Details",
    },
    header: {
      title: "Dashboard",
      welcomePhrases: {
        morning: "Good Morning",
        afternoon: "Good Afternoon",
        evening: "Good Evening",
      },
    },
    dashboard: {
      addPortfolio: "Add portfolio",
      header: {
        subheader: "Current assets",
        add: "Add portfolio",
      },
      noDataFirstLine: "There is currently no data available.",
      noDataSecondLine:
        "<linkText>Please import<linkText> your portfolios and accounts.",
      mainDataSection: {
        cash: "Cash",
        holdings: "Holdings",
        assets: "Assets",
        returnOnInvestment: "Price Gain",
        rateOfReturn: "Internal Rate of Return",
        dividends: "Dividends",
        realizedGain: "Realized Gains",
      },
      includeDividends: "Including dividends",
      cashTable: {
        header: "Cash",
      },
      investmentsTable: {
        header: "Holdings",
        columns: {
          name: "Name",
          totalValue: "Total Value",
          change: "Change",
          allocation: "Allocation",
        },
        types: {
          "11_stock_one": "Stock",
          "11_stock_other": "Stocks",
          "21_fund_one": "Fund",
          "21_fund_other": "Funds",
          "31_bond_one": "Bond",
          "31_bond_other": "Bonds",
          "41_cash": "Cash",
          "51_certos_one ": "Certificate / OS",
          "51_certos_other": "Certificates / OS",
          "61_pmetals_one": "Precious metal",
          "61_pmetals_othere": "Precious metals",
          "71_massets_one": "Material asset",
          "71_massets_other": "Material assets",
          "81_fcurr_one ": "Foreign Currency",
          "81_fcurr_other": "Foreign Currency",
          "22_etf": "ETF",
          "91_managed": "Robo Crowd",
        },
      },
      performance: {
        tabs: {
          value: {
            title: "Wert",
            portfolio: "Portfolio",
            investedCapitol: "Invested Capital",
          },
          performance: {
            title: "Performance",
            portfolio: "Portfolio",
            dividends: "Portfolio incl. Dividends",
          },
          dividend: {
            title: "Dividend",
            total: "Total",
            predicted: "Predicted",
            investedCapitol: "Investiertes Kapital",
          },
        },
        rangeName: {
          today: "Today",
          YTD: "YTD",
          oneYear: "1 year",
        },
        viewInvestedCapital: "View invested capital",
        compare: "Comparison",
        compareWith: "Compare with",
        compareTooltip: "Compare performance with a security or index.",
        includeDividends: "Including dividends",
      },
      gainersAndLosers: {
        gainers: "Gainers",
        losers: "Losers",
        more: "Learn more",
        period: "1 Day",
        noData:
          "No winners & losers available. Please change the portfolio selection or add further investments.",
      },
      communityPosts: {
        title: "Most Discussed",
        allDiscussions: "All Discussions",
        noPosts: "No discussions available",
      },
      arivaTimeline: {
        title: "Latest on your investments",
        empty: "No timeline items available",
        today: "Today",
        future: "Upcoming",
        past: "Yesterday",
      },
      newsBlock: {
        title: "News & Knowledge",
        allArticles: "See all articles",
        item: {
          type: "Rentablo blog",
        },
      },
    },
    cashbackSuggestionCard: {
      subtitle: "Profit even more!",
      title: "{{amount}} fund commission p.a.",
      discount: "Including 100% premium discount",
      button: "Get money back now",
    },
  },
  watchlistsPage: {
    title: "Watchlist",
    watchlists: {
      create: "Create a new watchlist",
      newWatchlist: "Add Watchlist",
    },
    createAndEditForm: {
      label: "Watchlist name",
      placeholder: "Watchlist name",
    },
  },
  watchlistsCreatePage: {
    breadcrumbs: {
      home: "Home",
      watchlists: "Watchlists",
      create: "Create",
    },
    header: {
      title: "Create watchlist",
    },
  },
  watchlistsEditPage: {
    breadcrumbs: {
      home: "Home",
      watchlists: "Watchlists",
      edit: "Edit",
    },
    header: {
      title: "Edit",
    },
  },
  watchlistSinglePage: {
    header: {
      totalItems_one: "{{count}} security",
      totalItems_other: "{{count}} securities",
      actions: {
        editWatchlist: "Edit watchlist",
        deleteWatchlist: "Delete watchlist",
        addNewItem: "Add new security",
      },
      deleteDialog: {
        title: "Delete watchlist",
      },
    },
    table: {
      noItems: "There are no securities",
      headers: {
        name: "Name",
        watchPrice: "Watch price",
        currentPrice: "Current price",
        changeToday: "Change Today",
        oneYear: "1 Year %",
        threeYear: "3 Years %",
        fiveYear: "5 Years %",
      },
    },
  },
  singleSecurityPage: {
    breadcrumbs: {
      quotes: "Security",
    },
    actions: {
      addToDepot: "Add to portfolio",
    },
  },
  depots: {
    title: "Depots",
    depotsTitle_one: "{{count}} Depot",
    depotsTitle_other: "{{count}} Depots",
    noAccountsTitle: "No depots",
    noAccountsSubtitle:
      "You do not have any depots, do you want to add them now?",
    noAccountsButtonText: "Add now",
    addManuallyButton: "Manually",
    deleteModal: {
      question: "Delete this depot?",
    },
  },
  depotPage: {
    breadcrumbs: {
      home: "Home",
      depots: "Depots",
    },
    header: {
      title: {
        mobile: "Depot",
      },
    },
    headerMenu: {
      upload: "Upload PDF",
      addButton: "Add investment",
      edit: "Edit",
      showUpdateHistory: "Show update history",
      manageBankConnection: "Manage bank connection",
      transfer: "Transfer depot",
      changeAccount: "Change reference account",
      hide: "Hide",
      show: "Show",
      delete: "Delete Depot",
      update: "Update",
      reconnect: "Reconnect",
    },
    deleteModal: {
      question: "Delete this depot?",
      deleteContraAccount: "Delete contra account",
    },
    chart: {
      performanceYTD: "{{changeYTD}} performance",
      performanceToday: "Today:{{changeToday}}",
      noData: "No data is currently available",
    },
    tabs: {
      transactions: "Transactions",
      investments: "Investments",
    },
    showHistoricSwitch: "Show historic",
    subcategories: {
      depots: "Depots & Verrechnungskonten",
      cash: "Accounts",
      assets: "Precious Metals & Tangible Assets",
      insurance: "Insurance",
    },
    addOptions: {
      depots: "Depots",
      cash: "Accounts",
      assets: "Precious Metals & Tangible Assets",
      insurance: "Insurance",
    },
  },
  depotsSelect: {
    title: "Select items",
    saveButton: "Create list",
    table: {
      headers: {
        name: "Name",
        bank: "Bank",
      },
    },
  },
  loginPage: {
    header: {
      title: "Log in to Rentablo",
      subtitle: "Enter your login details.",
    },
    form: {
      emailField: "Your email address",
      emailFieldPlaceholder: "name@email.com",
      passwordField: "Password",
      passwordFieldPlaceholder: "Enter password",
      submitButton: "Log in",
      twoFACodeLabel: "Enter 2FA code",
      twoFASubmitButton: "Confirm 2FA and log in",
      rememberMe: "Stay signed in",
      requestErrors: {
        loginFailed:
          "Login failed. <passwordRestoreLink>Did you forget your password?</passwordRestoreLink>",
        somethingWrongWithoutStatus:
          "Sorry, something went wrong. Try again. Please contact our support using <supportEmailLink>{{email}}</supportEmailLink> if this problem persist.",
      },
    },
    signupMessage: {
      link: "Register",
      question: "No account yet?",
    },
    resetPassword: {
      question: "Forgot your password?",
      link: "Click here",
    },
    twoFACodeError:
      "Invalid or expired code. Please try again and <linkText>log in</linkText>.",
  },
  signupPage: {
    header: {
      title: "Get an overview & Cash back for your finances",
      subtitle: "Rentablo is free & without obligation",
    },
    form: {
      firstName: "Name",
      lastName: "Surname",
      email: "Your email address",
      password: "Password",
      acceptedAgb:
        "I agree to the <agb>Rentablo terms</agb> and <privacy>privacy agreements</privacy>.",
      news: "Yes, I would like to receive updates about products and deals.",
      submitButton: "Singup to Rentablo",
      rememberMe: "Stay signed in",
      gender: {
        title: "Salutation",
        male: "Mr",
        female: "Mrs",
      },
      errors: {
        agb: "Terms & Privacy Policy: Must be specified",
      },
      requestErrors: {
        somethingWrongWithoutStatus:
          "Sorry, something went wrong. Try again. Please contact our support using <supportEmailLink>{{email}}</supportEmailLink> if this problem persist.",
      },
    },
    loginMessage: {
      linkText: "Login now",
      question: "Already registered?",
    },
  },
  resetPasswordPage: {
    header: {
      title: "Forgot your password",
      subtitle:
        "Please enter your e-mail address; below you will receive a link to reset your password by e-mail.",
    },
    form: {
      email: "Email:",
      submitButton: "Send Email",
      successfulMessage:
        "We have sent you an email to reset your password ({{email}}).",
    },
  },
  assignPasswordPage: {
    header: { title: "Assign new password" },
    form: { password: "Password", submit: "Change password" },
    success: "Your password was successfully changed",
    error: "Something went wrong. Please try again",
  },
  depotsAccountsPage: {
    noResults: "No suitable results found",
    showHiddenItems: "Show hidden elements",
    chips: {
      all: "All",
      "01_depot": "Deposits & Clearing Accounts",
      "02_cash": "Accounts",
      "04_insurance": "Insurance",
      "05_material_assets": "Precious metals and tangible assets",
    },
    accountChips: {
      manual: "User-generated",
      manualTooltip:
        "Please check and update changes/details based on the depot statement yourself.",
      manualUpdateRequired: "Manual",
      manualUpdateRequiredTooltip: "Manual update required",
      automatic: "Automatic",
      automaticTooltip: "Automatic update",
      updated: "Bank update {{date}}",
      edited: "Change {{date}}",
    },
  },
  accounts: {
    title: "Accounts",
    addButton: "Add",
    breadcrumbs: {
      home: "Home",
      add: "Add",
      addManually: "Manually",
    },
    updateAccount: "Update financial data",
    addMobileTitle: "Add account",
    addManuallyButton: "Manually",
    noAccountsTitle: "No accounts",
    noAccountsSubtitle:
      "You do not have any accounts, do you want to add them now?",
    noAccountsButtonText: "Add now",
    fillForm: "Please fill the form",
    chooseType: "Choose type",
    name: "Name",
    create: "Create",
    addManually: {
      chooseType: "Account Type",
      type: "Type",
      name: "Name",
      namePlaceholder: "E.g. My Depot",
      bank: "Bank",
      bankPlaceholder: "Bank Name, BIC or IBAN",
      create: "Create",
      back: "Back",
    },
    add: {
      title: "Import or manually enter?",
      subtitle: "You have various options to import your data",
      titleBank: "Import Depots/Accounts",
      subtitleBank: "Please select your bank",
      titleManual: "Create manually maintained portfolio",
      importBank: "Automated Import",
      importManual: "Manual Import",
      iWantTo: "I want to import this way:",
      bank: "Bank Import",
      importManualDepot: "Create Manual Portfolio",
    },
    sort: {
      name: "Name",
      bankName: "Bank name",
      performance: "Course/Change",
      totalValue: "Total value",
    },
    showHiddenItems: "Show hidden items",
  },
  transactionDetails: {
    productName: "Product name",
    numberOfLots: "Number of lots",
    entryQuote: "Quote",
    assetType: "Asset type",
    isin: "ISIN",
  },
  transactionsTable: {
    depotValue: "Depot value",
    period: "Period",
    valueDate: "Value date",
    bookingDate: "Booking date",
    bookingInformation: "Booking information",
    value: "Value",
    noPurpose: "Not available",
    noTransactions: "No transactions for the time range",
    status: {
      edit: {
        title: "Manual data",
        text: "No action required. The data was entered manually by the user.",
      },
      link: {
        title: "Bank import data",
        text: "No action required. The bank or broker has transmitted the exact amount and the exact number of items for this transaction. This is the best case and provides precise data.",
      },
      returned: {
        title: "Estimated Data",
        text: "Please check data. The bank or broker provided the exact amount, but NOT the number of pieces. The number of pieces was therefore estimated based on historical price data. This generally works well if there are not too many transactions.",
      },
      warning: {
        title: "Virtual balancing booking (quantity below zero)",
        text: "Needs action: Please correct data. A virtual booking had to be created to prevent the number of items from falling below zero at any time. Such a case can occur if data is missing or an estimate is incorrect.",
      },
      warningDelta: {
        title: "Virtual booking (deviation in quantity)",
        text: "Need for action: Please correct data. There was a deviation (also called tracking error) between the number of units calculated from the order history and the number of units reported by the bank. Such tracking errors can be due to data inconsistencies or due to corporate measures such as carve-out. Outs, portfolio transfers or splits occur.",
      },
      csv: {
        title: "CSV Import Data",
        text: "No action required. The exact amount and quantity for this transaction were transmitted via CSV import. This is the best-case scenario and provides precise data.",
      },
    },
  },
  investmentsTable: {
    noAccountNumber: "No number",
    noLastSyncDate: "No date",
    summary: {
      priceGains: "Price gains",
      today: "Today",
      purchaseValue: "Purchase value",
      marketValue: "Market value",
    },
  },
  bookingsTable: {
    overallValue: "Depot value",
    period: "Period",
    valueDate: "Value date",
    investment: "Investment",
    price: "Price",
    value: "Value",
    noBookings: "No bookings for the time range",
    exchangeRate: "Exchange rate: ",
  },
  assetClassName: {
    "11_stock": "Stock",
    "71_massets": "Material Assets",
    "91_managed": "Managed",
    "21_fund": "Fund",
    "22_etf": "ETF",
    "51_certos": "Certificates/OS",
  },
  accountView: {
    noBank: "No bank",
  },
  accountBox: {
    noBank: "No bank",
  },
  mainChartLayout: {
    timeBrushClose: "Close",
    timeBrushOpen: "Time brush",
  },
  viewLayout: { close: "Close" },
  performanceOverview: {
    performance: "Performance",
    gainAndLoss: "G/L (Market returns + realized)",
    returnOnInvestment: "Market returns",
    realizedGains: "Realized gains",
  },

  dividendsChart: {
    title: "Historic dividends",
    subtitle: "The dividend payout history",
    tooltip:
      "The companies dividend payment history. All values are aggregated for full years.",
  },
  historicalQuotesChart: {
    title: "Historic market return up to now",
    subtitle:
      "This is the market or share-price return from N years up to now.",
    tooltip: "This is the market or share-price return from N years up to now.",
    year_one: "{{count}} Year",
    year_other: "{{count}} Years",
  },
  investmentChartTooltip: {
    buy: "Buy",
    sell: "Sell",
    dividend: "Dividend",
    book_in: "Book in",
    book_out: "Book out",
    retained_dividend: "Retained dividend",
    purchase_right: "Purchase right",
    carve_out: "Carve out",
    split: "Split",
    expected_dividend: "Expected dividend",
  },
  assetTypeBreakdown: {
    allHoldings: { title: "Holdings", noData: "No holdings" },
    funds: { title: "Funds", noData: "No funds" },
    etfs: { title: "ETF", noData: "No ETF" },
    derivative: { title: "Derivative", noData: "No derivative" },
    bonds: { title: "Bonds", noData: "No bonds" },
  },
  breadcrumbs: {
    home: "Home",
    investments: "Investments",
    cashback: "Cashback",
    depotsAccounts: "Portfolios & Accounts",
    accounts: "Accounts",
    addDividends: "Add dividends",
    recommend: "Recommendation",
    cashflow: "Cashflow Analyzer",
    contract: "Contract Analyzer",
  },
  tradeRepublic: {
    connectFrom: {
      phone: {
        label: "Phone",
        helperText: "International format, ex.: +4915753345623",
      },
      pin: { label: "PIN", helperText: "four digits, ex.: 1234" },
      submit: "Send",
    },
    codeFrom: {
      code: {
        label: "Code from app",
        helperText: "four digits, ex.: 1234",
      },
      submit: "Sync Data",
    },
    error: {
      title: "Error",
      message: "Please contact Rentablo support.",
    },
    success: {
      title: "Success",
      message: "Data is synced. Thanks for help.",
    },
  },
  accountChart: {
    subtitle: "Current account balance",
  },
  admin: {
    logos: {
      title: "Company or emitter logo",
      breadrcumb: "Company logo",
      add: "Add logo",
      searchButton: "Logo",
      isin: "ISIN",
      name: "Name",
      logo: "Logo",
      date: "Date",
      addTitle: "Add logo",
      logoUpload: "Drag or select logo here",
      bannerTitle: "Change current logo",
      bannerDescription:
        "The current logo will be replaced by the new logo once you upload and save the new logo",
      bannerButton: "Okay",
      noLogos: "No logos found",
      deleteThisLogo: "Delete this logo?",
      succesUpload: "The logo was uploaded successfully",
    },
    etfs: {
      title: "ETF/ETC Classification",
      add: "Add classification",
      deleteThisClassification: "Delete this classification?",
      isin: "ISIN",
      name: "Name",
      type: "Classification",
      date: "Date",
      apply: "Search",
      noEtfs: "No ETFs/ETCs found",
    },
    names: {
      title: "Preferred names",
      add: "Add preferred name",
      edit: "Edit preferred name",
      isin: "ISIN",
      deleteThisName: "Delete this name?",
      standardName: "Standard name",
      preferredName: "Preferred name",
      date: "Date",
      search: "Search",
      apply: "Save",
      noNames: "Nothing found",
    },
    assetReport: {
      title: "Asset Report",
      emitters: {
        label: "Fund ETF Issuer",
        all: "All",
        funds: "Fund Issuer",
        etfs: "ETF Issuer",
      },
      issuer: { label: "Select issuer", placeholder: "Enter name" },
      isins: {
        label:
          "Insert ISINs (Please enter the individual ISINs separated by commas without spaces)",
        placeholder: "Insert ISINs",
      },
      startDate: { label: "Date from (Optional)" },
      endDate: { label: "Date to (Optional)" },
      button: "Generate report",
      table: {
        tabTitle: "Table",
        emitters: "Issuers",
        isins: "ISINs",
        from: "Date from",
        startVolume: "Start volume",
        to: "Date to",
        endVolume: "End volume",
        delta: "Delta",
        total: "Total amount:",
      },
    },
    splits: {
      mainPage: {
        breadcrumbs: {
          splits: "Splits Management",
        },
        title: "Splits Management",
        addButton: "Split",
        noSplits: "No splits found",
        apply: "Apply",
        deleteThisSplit: "Delete this split?",
      },
      editPage: {
        submit: "Submit",
        breadcrumbs: {
          edit: "Edit split",
          add: "Add split",
        },
      },
    },
    dividends: {
      save: "Save",
      close: "Cancel",
      clone: "Copy dividends",
      mainPage: {
        title: "Manage dividends",
        breadcrumbs: { dividends: "Manage dividends" },
        noDividends: "No dividends found ",
        apply: "Apply",
        deleteThisDividend: "Delete this dividend?",
        noIsin: "No ISIN specified. Please provide an ISIN",
      },
      cloneModal: {
        title: "Copy dividends",
        success: "Dividends copied successfully ",
      },
      addPage: {
        title: "Add dividend",
      },
      editPage: {
        title: "Edit dividend",
        fields: {
          isin: "ISIN",
          amount: "Amount",
          currency: "Currency",
          exDate: "Execution Date",
          paymentDate: "Payment date",
          splitAdjustedAmount: "Split adjusted amount",
          amountInCurrency: "Amount in currency",
          splitAdjustedAmountInCurrency: "Split adjusted amount in currency",
          markedAsDeleted: "Marked as deleted",
          wasCurated: "Was curated",
          isSpecial: "Special",
        },
      },
    },
    interfaces: {
      editPage: {
        breadcrumbs: {
          edit: "",
          add: "",
        },
      },
      mainPage: {
        breadcrumbs: {
          interfaces: "Interfaces",
        },
      },
    },
    bankMessages: {
      title: "Bank message overview",
      createNew: "Create message",
      breadcrumbs: { bankMessages: "Message overview" },
      filterBy: "Filter by",
      createSuccess: "Message created successfully",
      createError: "Message could not created",
      deleteSuccess: "Message deleted successfully",
      deleteError: "Message could not be deleted",
      updateSuccess: "Message updated successfully",
      updateError: "Message could not be updated",
      copySuccess: "Message copied successfully",
      copyError: "Message could not be copied",
      table: {
        severity: "Message type",
        bic: "BIC",
        message_text: "Message text",
        valid_until: "Due date",
        unlimited: "Perpetual",
        expired: "Expired",
        expiresToday: " Expires today",
        expiresIn_one: "Due in {{amount}} day",
        expiresIn_other: "Due in {{amount}} days",
        expiresInHours_one: "Due in {{amount}} hour",
        expiresInHours_other: "Due in { {amount}} hours",
        INFO: "Info",
        WARNING: "Warning",
        ERROR: "Error",
        edit: "Edit",
        copy: "Copy",
        delete: "Delete",
      },
      form: {
        limited: "Limited message",
        message_text: "Message text",
        message_text_placeholder: "Enter text",
        severity: "Severity",
        bic: "BIC",
        start_date: "Date from",
        start_date_tooltip:
          'Please select the start date for displaying the message. If you select today as the start date, the message will be displayed immediately after clicking the "Update message" button. If you select a future date, the message will be displayed from midnight on the selected day.',
        end_date: "Date until",
        end_date_tooltip:
          "Please select the end date for displaying the message. The message will be displayed until midnight on the selected day.",
      },
      newModal: { title: "Create message", submit: "Create message" },
      editModal: { title: "Use message again", submit: "Update message" },
    },
    bankEvents: {
      title: "Bank Connection Events",
      userId: "User ID",
      userId_placeholder: "Enter User ID",
      table: {
        date: "Date",
        bankName: "Bank Name",
        faq: "FAQ",
        copyCode: "Copy code",
        warning: "Warning",
        error: "Error",
        info: "Info",
        faqTooltip:
          'The link takes you to our wealthAPI Help Center. You must be logged in to Zendesk with your login details to access our FAQ. It\'s best to remember the "message" from the code. Enter the relevant keywords in the FAQ search so that the relevant entry is displayed.',
      },
    },
    cashbackBookings: {
      title: "Cashback Bookings",
      mandatorLabel: "Filter by mandator (default: all mandators)",
      absByMonth: "Cashback subscriptions absolute by month",
      mailReturnByMonth: "Subscription mail return rate in percent by month",
      averageMailReturn: "Average mail return rate is {{value}}",
      churnByMonth: "Subscription churn rate in percent by month",
      avgChurnRate: "Average churn rate is {{value}}",
      currentAssetsByBank: "Current assets by bank",
      totalManagedByMonth: "Total managed assets by month",
    },
    apiRefresh: {
      title: "Historic Quotes Refresh",
      hqIsin: {
        isinLabel: "ISIN",
      },
      hqTicker: {
        tickerLabel: "Ticker symbol",
        quoteLabel: "Quote provider",
      },
      button: "Refresh",
      successMessage: "Refreshed succesfully",
      errorMessage: "Refresh failed",
    },
    bankLogs: {
      title: "Bank Sync Logs",
      subtitle:
        "Using a user ID, you can display the import data for a selected bank for a certain period of time. The log files are made available to you as a code when you click on an entry in the table.",
      form: {
        start_date: "Date from",
        start_date_tooltip:
          "Please select the start date for the desired period",
        end_date: "Date to",
        end_date_tooltip: "Please select the end date for the desired period ",
        userId: "User ID",
        bank: "Bank",
      },
      table: {
        date: "Time",
        logId: "Log ID",
        userId: "User ID",
        noData: "No data",
      },
    },
    bankHealth: {
      title: "Bank Health Reports",
      tabs: { table: "Table", chart: "Chart view", errors: "Tracking error" },
      form: {
        start_date: "Date from",
        start_date_tooltip:
          "Please select the start date for the desired period off",
        end_date: "Date to",
        end_date_tooltip: "Please select the end date for the desired period",
        bank: "Bank",
        interval: "Interval",
        interval_tooltip:
          "Please select the desired time interval for the analysis. You can choose between 15 minute, 1 hour, daily and weekly intervals. Please note that the availability of certain intervals depends on the preset period (from... to).",
        day: "Day",
        week: "Week",
        quarter: "15 minutes",
        hour: "Hour",
      },
      table: {
        date: "Date",
        interval: "Time",
        includeUserErrors: "User-based errors",
        successRate: "Success rate",
        failureRate: "Error rate",
        noData: "No data",
      },
      errors: { isin: "ISIN", count: "Number of tracking errors" },
    },
    cryptoRefresh: {
      title: "Crypto Currencies",
      form: {
        coinGeckoId: "CoinGecko ID",
      },
      addButton: "Add",
      successMessage: "Crypto currency added successfully",
      errorMessage: "Failed to add crypto currency",
      refreshButton: "Refresh",
      refreshSuccessMessage: "Crypto currency refreshed successfully",
      refreshErrorMessage: "Failed to refresh crypto currency",
    },
  },
  interfaceSelectionOptions: {
    "checking.accounts": "Checking Accounts",
    "depots.and.reference.accounts": "Depots and reference accounts",
    "depots.and.other.accounts": "Depots and other accounts",
    "other.accounts": "Other accounts",
    "credit.cards": "Credit Cards",
    "depots.and.savings.and.credit.cards":
      "Depots, savings accounts & credit cards",
  },
  redesign: {
    header: {
      actions: {
        fundDiscount: "Fund Discount",
        yourDiscount: "Your benefits",
        depotManagerApp: "Depot Manager App",
        aboutUs: "About us",
        knowledge: "knowledge",
        login: "login",
        becomeCustomer: "Become a customer",
        inApp: "Home",
        cashback: "Request cashback",
        faqs: "FAQs",
        forum: "forum",
        blog: "blog",
        support: "support",
      },
    },
    footer: {
      copyright: "A trademark of wealthAPI GmbH",
      column1: {
        title: "Company",
        items: [
          {
            href: "https://rentablo.de/aboutUs",
            title: "About us",
          },
          {
            href: "https://rentablo.de/jobs",
            title: "Jobs & Careers",
          },
          {
            href: "https://www.financequality.net/partnerprogramme/rentablo-fond-cashback/",
            title: "Affiliate Program",
          },
          {
            href: "https://rentablo.de/Sicherheit",
            title: "Security",
          },
          {
            href: "https://wealthapi.eu",
            title: "Business Customers",
          },
        ],
      },
      column2: {
        title: "Features",
        items: [
          {
            href: "https://rentablo.de/software-depotverwaltung",
            title: "Software Depot Management",
          },
          {
            href: "https://rentablo.de/portfolio-performance",
            title: "Portfolio Performance",
          },
          {
            href: "https://rentablo.de/portfolio-optimization",
            title: "Portfolio Optimization",
          },
          {
            href: "https://rentablo.de/kostenloser-finanzmanager-online",
            title: "Free Portfolio Manager",
          },
          {
            href: "https://rentablo.de/elektronisches-budget",
            title: "Electronic Household Book",
          },
        ],
      },
      column3: {
        title: "Knowledge & Financial Tools",
        items: [
          {
            href: "https://forum.rentablo.de/",
            title: "Forum & FAQ",
          },
          {
            href: "https://blog.rentablo.de/",
            title: "Financial Blog",
          },
          {
            href: "https://rentablo.de#cashback-calculator",
            title: "Fund Discount Calculator",
          },
          {
            href: "https://rentablo.de/investment/popularFunds",
            title: "Popular Funds",
          },
        ],
      },
      column4: {
        title: "Financial Tools & Knowledge",
        items: [
          {
            href: "https://forum.rentablo.de/",
            title: "Forum & FAQ",
          },
          {
            href: "https://blog.rentablo.de/",
            title: "Financial Blog",
          },
          {
            href: "https://rentablo.de/kostenloser-finanzmanager-online",
            title: "Free Portfolio Manager",
          },
          {
            href: "https://rentablo.de/elektronisches-budget",
            title: "Electronic Household Book",
          },
          {
            href: "https://blog.rentablo.de/vergleichsrechner-und-finanztools/",
            title: "Comparison Calculator",
          },
        ],
      },
      subFooterItems: [
        {
          href: "impressum",
          title: "Impressum",
        },
        {
          href: "privacy",
          title: "Privacy Policy",
        },
        {
          href: "agb",
          title: "Terms and Conditions",
        },
        {
          href: "disclaimer",
          title: "Disclaimer",
        },
      ],
    },
  },
  addToDepot: "Add to Depot",
  addToWatchlist: "Add to Watchlist",
  showMore: "show more",
  supportCard: {
    caption: "I am responsible for you",
    title: "Patrick Rujan",
    subtitle: "Customer Support Rentablo",
  },
  bankSelect: {
    pageTitle: "Import depots/accounts",
    title: "Please search bank",
    searchLabel: "Search: name, IBAN, bank code, BIC",
    selectBic: {
      title:
        "Please select your BIC. <bold>BIC</bold> (Bank Identifier Code) is an <bold>8 or 11-digit bank sort code</bold> that <bold>uniquely identifies financial institutions worldwide</bold> can be.",
      back: "Back",
    },
    notFound: "Bank not found.",
    notSupported: "The bank is currently not supported.",
  },
  netfondsOnboarding: {
    next: "Save and continue",
    sidebar: {
      main: "Onboarding",
      preferences: "Investment goals and preferences",
      sustainability: "Sustainability",
      signup: "Registration",
      experience: "Knowledge & Experience",
      personal: "Personal data",
    },
    investmentGoal: {
      title: "What is your investment objective?",
      valueRetention: "Maintaining value at capital market interest rates",
      longTermInvestment: "Long-term asset accumulation",
      shortTermProfit: "Short-term intention to make a profit",
      additionalIncome:
        "Achieving additional income while accepting higher risks",
    },
    investmentHorizon: {
      title: "How long do you want to invest?",
      shortTerm: "0-3 years",
      midTerm: "3-5 years",
      longTerm: "> 5 years",
    },
    preferredRiskClass: {
      title: " Please indicate your risk tolerance",
      riskClassB: "Return - risk class B",
      riskClassB_subtitle:
        "You only have a <b>low expectation of return<b>. Maintaining the value of the entire portfolio is your priority. You therefore only want <b> low risks<b> due to market fluctuations (e.g. price, interest rate and currency fluctuations) and only take a low risk of loss for the entire portfolio. <b>Risk tolerance - 5%<b> after costs.",
      riskClassC: "Balanced - Risk class C",
      riskClassC_subtitle:
        "You have a <b>moderate expected return<b>. In addition to interest income, income from price increases is also sought. In return, you accept <b>moderate risks<b> due to market fluctuations (e.g. price, interest rate and currency fluctuations) and moderate risks of loss for the entire portfolio. <b>Risk tolerance - 30%<b> after costs.",
      riskClassD: "Growth - risk class D",
      riskClassD_subtitle:
        "You expect <b>higher returns<b> that are above the capital market interest rate level for as long as possible. In return, you accept <b>higher risks<b> due to market fluctuations (e.g. price, interest rate and currency fluctuations) and higher risks of loss for the entire portfolio. <b>Risk tolerance - 50%<b> after cost.",
    },
    sustainabilityPreference: {
      title: "Choose sustainability preferences",
      important: "Yes, sustainable investments are important to me",
      notImportant: "No, sustainable investments are not important to me",
      notSure: "I am still undecided, not at the moment",
    },
    sustainabilityFactors: {
      title: "Which other sustainability factors are important to you?",
      climateProtection:
        "Climate protection, adaptation to climate change (taxonomy)",
      climateProtection_tooltipTitle: "EU taxonomy",
      climateProtection_tooltipText:
        "Classification system for sustainable economic activities within the EU with currently 6 Focus on environmental goals. Requirement: A company must make a contribution to at least one environmental goal and not violate the other environmental goals and comply with the minimum requirements in the areas of governance, human and employee rights. The proportion of ecologically sustainable investments in the sense of the taxonomy regulation is expressed in percent with values of 0 to 100. The higher the value, the more positive it is in the sense of ecologically sustainable.",
      unSustainableDevelopmentGoals:
        "UN Sustainable Development Goals (Disclosure)",
      unSustainableDevelopmentGoals_tooltipTitle:
        "UN Sustainable Development Goals (Disclosure)",
      unSustainableDevelopmentGoals_tooltipText:
        "Rating , the extent to which companies use opportunities to achieve the 17 Sustainable Development Goals (SDGs) defined by the UN. The value scale ranges from -100% (significant hindrance) to 100% (significant contribution to achieving the goal).",
      exclusionsTitle:
        "Please select which absolute exclusions are important to you for the investment",
      gasEmission: "Greenhouse gas emissions",
      gasEmission_tooltipTitle: "Greenhouse gas emissions",
      gasEmission_tooltipText:
        "Direct and indirect release of climate-damaging gases and involvement in the field of fossil fuels",
      hazardousWaste: "Hazardous waste",
      hazardousWaste_tooltipTitle: "Hazardous waste",
      hazardousWaste_tooltipText: "Hazardous waste generated by the company",
      waterPollution: "Pollution of water",
      waterPollution_tooltipTitle: "Pollution of water",
      waterPollution_tooltipText:
        "Determination of chemical oxygen demand (COD) to assess the contamination of wastewater with organic substances",
      negativeImpact: "Negative impact on biodiversity",
      negativeImpact_tooltipTitle: " Negative impact on biodiversity",
      negativeImpact_tooltipText:
        "Activities with a negative impact on biodiversity-sensitive areas",
      socialEmployment: "Social and employee issues",
      socialEmployment_tooltipTitle: "Social and employee issues",
      socialEmployment_tooltipText:
        "Violations of the UNGCOECD guidelines and unadjusted gender pay gap",
      sustainabilityClass: {
        title: "Your sustainability class",
        text: "Your sustainability class is currently 1 of 5.",
        link: "further information",
      },
      subtitle: "",
    },
    details: {
      title: "Configure the details of your investment",
      strategy: "Your investment strategy",
      chartTitle: "Expected asset performance",
      return: "Return",
      volatility: "Volatility",
      "10-years": "10 years",
      "20-years": "20 years",
      investmentAmount: "Your initial investment",
      savingsPlan: "Your monthly savings plan",
    },
    signup: {
      title: "Registration",
      email: "Your email address",
      email_placeholder: "Please enter your email address...",
      password: "Password",
      password_placeholder: "Please set a password... ",
      acceptedTerms:
        "I consent to the processing of my data. These will be sent to Musterfinanz as the asset management agent, to Netfonds AG as the processor and to the respective custodian bank for opening the custody account. You can find further information on the use of your data in the <link>Data protection declaration<link>.",
      receiveNewsletter:
        "I would like to <link1>be regularly informed<link1> about new offers. Your consent hereby can be revoked at any time (by email to <link2>max.mustermann@ musterfinanz.de<link2> or to the contact details given in the imprint).",
    },
    systemKnowledge: {
      title: "Which investments do you have knowledge of?",
      subtitle: "Multiple selection possible",
      shares: "Stocks",
      funds: "Funds",
      security3: "Security 3",
      security4: "Security 4",
      noKnowledge: "No knowledge",
    },
    investmentExperience: {
      title: "What is your experience with these investments?",
      subtitle: "Number of transactions in the last 5 years.",
      shares: "Stocks",
      funds: "Fonds",
      security3: "Security 3",
      security4: "Security 4",
      "1-5-years": "1-5 years",
      "more-than-5-years": "> 5 years",
      noExperience: "None",
    },
    netIncomePerMonth: {
      title: "Monthly net income",
      netIncomePerMonth: "How much are your monthly net income?",
    },
    expensesPerMonth: {
      title: "Monthly expenses",
      expensesPerMonth: "How much are your monthly expenses?",
    },
    assets: {
      title:
        "Do you own assets in the form of real estate or investments? If so, how much are these assets approximately?",
      "more-than-0": "> 0 €",
      "more-than-25000": "> 25,000 €",
      "more-than-50000": "> 50,000 €",
      "more-than-75000": "> 75,000 €",
      "more-than-100000": "> 100,000 €",
      other: "other information",
      realEstateAssets: "Your assets in real estate investments",
    },
    personalData: {
      title: "Please enter your personal data",
      subtitle:
        "The information is required by your bank to open a securities account",
      gender: "Salutation",
      gender_placeholder: "Choose a salutation",
      academicTitle: "Academic title ",
      academicTitle_placeholder: "Choose your title",
      firstName: "First name",
      firstName_placeholder: "Your first name",
      lastName: "Last name",
      lastName_placeholder: "Your last name",
      dateOfBirth: "Date of birth",
      placeOfBirth: "Place of birth",
      placeOfBirth_placeholder: "Please specify place of birth",
      countryOfBirth: "Country of birth",
      countryOfBirth_placeholder: "Please select your country of birth",
      maritalStatus: "Marital status",
      maritalStatus_placeholder: "Please select your marital status",
      phoneNumber: "Tel. Mobile",
      phoneNumber_placeholder: " Please enter your mobile phone number",
      email: "E-Mail",
      email_placeholder: "Please enter your email address",
      education: "Training",
      education_placeholder: "Please select your training",
      occupation: "Profession",
      occupation_placeholder: "Please select your occupation",
      sector: "Industry",
      sector_placeholder: "Please select an industry",
    },
    addressData: {
      title: "Please enter your address",
      subtitle:
        "The information is required by your bank to open a securities account",
      street: "Street",
      houseNumber: "House number",
      houseNumber_placeholder: "No.",
      zip: "Postal code",
      city: "Place of residence",
      city_placeholder: "Your place of residence",
      addressCountry: "Country",
      nationalityCountry: "Nationality",
    },
    taxationData: {
      title: "Your tax-relevant data",
      taxationCountry1: "Taxable in ",
      taxationNumber1: "Tax identification number",
      interText: "Do you have another tax residence?",
      taxationCountry2: "Taxable in ",
      taxationNumber2: "Tax identification number",
    },
    mifidData: {
      title: "Please enter your data for MiFID",
      isNotPoliticallyExposed: "I am not a politically exposed person",
      isNotPoliticallyExposed_tooltipTitle: "Politically exposed person",
      isNotPoliticallyExposed_tooltipText:
        "(PEP) are in accordance with Section 6 Paragraph 2 No. 1 Money Laundering Act Persons who hold or have held an important public office (e.g. politicians, ambassadors).\n" +
        "If you have any questions, please feel free to contact us or your advisor personally.",
      isOwnAccount: "I act on my own account ",
      isOwnAccount_tooltipTitle: "Beneficial owner",
      isOwnAccount_tooltipText:
        "If you are not trading on your own account, please contact us personally or your advisor - we will help you with the investment." +
        "For technical reasons Online strategy purchases are currently only possible for beneficial owners.",
    },
    contraAccount: {
      title: "Bank details",
      banner: {
        text: "A reference account is a checking account at your bank that is used to process payment transactions. When you buy securities, you transfer money from your reference account to the clearing account of your securities account. Your reference account must be SEPA-capable and managed in euros.",
      },
      iban: "IBAN",
      formSectionLabel: "Account holder of the reference account",
      contraAccountHolderFirstName: "First name",
      contraAccountHolderFirstName_placeholder:
        "First name of the account holder",
      contraAccountHolderLastName: "Last name",
      contraAccountHolderLastName_placeholder: "Account holder last name",
    },
    agreements: {
      title: "Agreements",
      subtitle: "Please read the following agreements carefully:",
      customerInfoAcknowlegmentAccepted:
        "I have received and acknowledged the <linkText>Customer Information<linkText>.",
      frameworkAgreementAccepted:
        "I I agree to the <linkText>framework agreement<linkText>",
      processingDataAccepted:
        "I consent to the processing of my data. This will be sent to wealthAPI Wolfram Stacklies, as a feeder to NFS Hamburger Vermögens GmbH, to Netfonds AG, as a processor and to the respective Deoptbank (FIL Fondsbank GmbH) to open the account and send investments in the selected strategies. Further information on the use of your data can be found in the <linkText>Data protection information<linkText>.",
      servicesPerfomanceAccepted:
        "I hereby declare myself in the I agree to carry out the commissioned services before the end of the cancellation period of 14 days after submitting my contractual declaration.",
    },
    consent: {
      title: "Consent to establish contact (Module A + B)",
      subtitle:
        "For reasons of better readability, the simultaneous use of the language forms male, female and diverse is avoided. All personal names apply equally to all genders. The customer agrees contact using the following means of communication:",
      sections: { 1: "Module A", 2: "Module B", 3: "Module C" },
      contactViaPhone:
        "by telephone or, if necessary, SMS (if a mobile phone number is provided",
      contactViaEmail: "via e-mail",
      contactViaFax: "via fax",
      contactViaMessengers:
        "via messenger service (Whatsapp, Signal, etc.) and/or internet telephony",
      contactViaElectronicCommunication:
        "via electronic mailbox using various authentication procedures",
      newsletterAccepted:
        "I agree to receive market information, newsletters and information on products and services via means of distance communication.",
      newsletterNotAccepted: "I do not consent",
      banner: {
        text: "Note: The declarations of consent are voluntary and can be used in whole or in part without affecting existing contractual relationships ( also for individual communication channels and modules). The conditions below apply to the individual modules A,B,C. ",
      },
      warning:
        "Please note that a combination of the individual modules is possible. ",
    },
  },
  finanzfluss: {
    bankConnections: {
      bankingCredentials: {
        storeSecrets: {
          info: "Your data will be stored securely encrypted. Only if the checkbox is checked can your account be updated automatically.",
        },
      },
      bankIsBusy: {
        bannerText:
          "There are currently a lot of parallel import requests being made to {{bankName}}. This may result in a temporary interruption of the connection by the broker. We ask for your understanding that the import of your {{ bankName}} depots is currently not possible. Please try again in a few minutes.",
      },
    },
  },
  feedbackPage: {
    title: "Your feedback helps us prioritize the right things.",
    intro:
      "Your feedback is invaluable to us ❤️️ and we are continually working to improve the Copilot and make your experience with it as positive as possible. <br > <br > On this page you can see what improvements we are currently making You can also tell us your own suggestions for improvement and vote on other users' suggestions. This will help us prioritize the right things.<br > <br > If you have any questions about using the Copilot or have technical problems, please contact us via 👉 <linkText >Send the following form<linkText> 👈 to us. Thank you for your support 🙏",
    link: "following form",
  },
  securitiesSearch: {
    title: "Search asset",
    placeholder: "Enter name, ISIN or WKN",
    all: "All",
    back: "Back to search results",
    isin: "ISIN",
    type: "Class",
    showMore: "Show more",
    loading: "Loading...",
    noResults: "No results",
  },
};
